import styled from 'styled-components';
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Line, Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import { AiOutlineClose } from 'react-icons/ai'; // Import close icon from react-icons
import { FiSearch, FiEye, FiEdit, FiTrash2, FiPlus, FiMinus } from 'react-icons/fi'; // Using react-icons library
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMale, faSignOutAlt, faCheckCircle, faClock, faExclamationTriangle, faUsers, faMobileAlt, faQrcode, faIdCard, faPrint } from '@fortawesome/free-solid-svg-icons'; // Import all the icons you need
import { Tooltip } from 'react-tooltip'; // Import Tooltip from react-tooltip
import { useNavigate, useLocation } from 'react-router-dom';
import { FiFilter } from 'react-icons/fi'; // Import the filter icon
import { FaRegBuilding } from "react-icons/fa"; // Entity filter icon (building)

import { fetchVisitorTypes, fetchIdProofTypes, fetchMeetingVenues, insertAppointment, fetchGateDetails, fetchBuildingsByGate, fetchNationality } from '../../services/Api';
import { ToastContainer, toast } from 'react-toastify';
import { User } from 'react-feather'; // Import the User icon
import Loader from '../../Loader/loader';
import { FiDownload } from 'react-icons/fi';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FaWalking, FaQrcode } from "react-icons/fa";

import { faEye } from '@fortawesome/free-solid-svg-icons';
import { useOutletContext } from 'react-router-dom';

const DashboardWrapper = styled.div`
  padding: 10px 35px 35px 35px;
`;

const PageHeading = styled.h2`
  text-align: left;
  font-size: 25px;
    color:#2B3497
`;

// const CardRow = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); 
//   gap: 12px; /* spacing between cards */
//   justify-items: center; /* center cards horizontally in each cell */
// `;
const CardRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
`;


const Card = styled.div`
  background-color: ${({ bgColor }) => bgColor || '#f8f8f8'};
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  flex: 1;
  min-width: 120px; /* Decreased minimum width for cards */
  max-width: 150px; /* Decreased maximum width for cards */
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  position: relative;
  transition: transform 0.3s, color 0.3s; /* Added color transition on hover */

  &:hover {
    transform: translateY(-5px); /* Lift card on hover */
    color: white; /* Change text color on hover */
    cursor:pointer;
  }
    /* Responsive adjustments */
     @media (max-width: 1550px) {
    max-width: 135px; /* Slightly decrease for large screens */
    min-width: 140px;
  }
  @media (max-width: 1470px) {
    max-width: 130px; /* Slightly decrease for large screens */
    min-width: 130px;
  }
    @media (max-width: 1400px) {
    max-width: 120px; /* Slightly decrease for large screens */
    min-width: 120px;
  }

  @media (max-width: 992px) {
    max-width: 150px; /* Adjust for tablets or smaller laptops */
    min-width: 130px;
  }

  @media (max-width: 768px) {
    max-width: 140px; /* Adjust for tablets */
    min-width: 120px;
    padding: 15px;
  }

`;

const CardTitle = styled.div`
  font-weight: 700;
  color: #333;
  text-transform: capitalize; /* Capitalize first letter of each word */
  ${Card}:hover & {
    color: white; /* Change count color to white on card hover */
  }
`;

const CardCount = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin-top: 10px;

  ${Card}:hover & {
    color: white; /* Change count color to white on card hover */
  }
`;

const ChartRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 20px;
`;

const ChartBox = styled.div`
  background: linear-gradient(180deg, #f8f8f8 0%, #d9d9d9 100%);
  box-shadow: 10px 10px 28px #00000021;
  border: 3px solid #ffffff;
  border-radius: 10px;
  opacity: 1;
  padding: 20px;
  text-align: center;
  flex: 1;
  min-width: 300px;
  max-width: 600px;
`;

const ChartHeader = styled.h3`
  color: #2b3497;
  margin-bottom: 20px;
`;
const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  background-color: #fff;
  color: #293495;
  border: 1px solid #3d46b4;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #293495;
  }
`;

const ZeroStateMessage = styled.div`
  margin-top: 20px;
  font-size: 18px;
  color: #666;
  text-align: center;
`;

const TableContainer = styled.div`
  margin-top: 20px;
  width: 100%;
  overflow-x: auto;

`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(to right, #e6e6e6, #f2f2f2, #f5f5f5, #f3f3f3, #e9e9e9);
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 9px 10px;
  text-align: left;
  cursor:pointer;
  font-size:12px;
  font-weight-600;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
  font-size:11px;
`;
const PageHeadingWrapper = styled.div`
  display: flex; /* Flexbox layout for alignment */
  align-items: center; /* Center items vertically */
  justify-content: space-between;
`;

const Button = styled.button`
  width: 51px;
  height: 32px;
  border-radius: 7px;
  box-shadow: 0px 5px 10px #2b349754;
  color: white;
  font-size: 14px;
  border: none;
  cursor: pointer;
  font-family: 'Segoe UI', Semibold;
  display: flex; /* Flex layout to center icon */
  align-items: center; /* Center icon vertically */
  justify-content: center; /* Center icon horizontally */
  background-color: #2b3497; /* Background color for button */

`;
const IconWrapper = styled.span`
  cursor: pointer;
  color: #2B3497;
  margin: 0 5px;
`;

const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
   background: #fff;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 400px;
  height: 125px;
`;
// const PopupCh = styled.div`
//   position: fixed;
//   top: 50%;
//   left: 55%;
//   transform: translate(-50%, -50%);
//    background: #fff;
//     box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
//     border-radius: 10px;
//   padding: 30px;
//   text-align: center;
//   opacity: 1;
//   z-index: 1000;
//   width: 400px;
//   height: 174px;
// `;
const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);   /* dark transparent layer */
  backdrop-filter: blur(3px);       /* blur background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const PopupCh = styled.div`
  background: #fff;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 30px;
  text-align: center;
  width: 400px;
  height: auto;
  z-index: 1000;
`;


const PopupText = styled.p`
  font-size: 18px;
  color: #2B3497;
  margin-bottom: 20px;
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  opacity: 1;
  cursor: pointer;
`;


const InputField = styled.input`
  background-color: transparent;
  width: 80%;
  height: 40px;
  padding: 1px;
  font-size: 14px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 2px solid #2B3497;
  border-radius: 0;
  text-align: left;
  outline: none;

  &::placeholder {
    color: #000000;
  }

  /* Remove up and down arrows for number input */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::-moz-appearance {
    textfield;
  }
`;
// Styled components
const Container = styled.div`
  display: flex;
  justify-content: space-between; /* Align items left and right */
  align-items: center; /* Center vertically */
`;
const DropdownGroup = styled.div`
  display: flex;
  gap: 20px; /* space between Gate & Entity dropdowns */
  align-items: center;
`;


const DropdownContainerTwo = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const SelectedOption = styled.div`
  margin-right: 10px;
  font-size: 14px;
  color: #000000;
  font-weight: 500;
`;

const FilterIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #293495;
`;

const OptionsPanel = styled.div`
  position: absolute;
  top: 30px;
  right: 0;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 150px;
  max-height: 300px; /* Ensures proper scroll area */
  overflow: auto;
  z-index: 10;
`;

const VirtualScroll = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 300px; /* Height for virtual scrolling */
`;

const OptionItem = styled.div`
  padding: 10px;
  cursor: pointer;
  text-align: left;
  &:hover {
    background-color: #f1f1f1;
  }
`;
const Circle = styled.div`
    width: 40px;
    height: 40px;
    background: linear-gradient(#ffffff, #f6f6f6);
    border-radius: 50%;
    box-shadow: 0px 10px 10px #00000024;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    // margin:14px 44px;
  `;
const ProfileIcon = styled.div`
  width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #2b3497;
    font-size: 30px;
    font-weight: bold;
    position: relative;
  `;
const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1; /* Ensure input takes up remaining space */
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000; /* Adjust color as needed */
`;
const DropdownContainerTwoo = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const ExportIcono = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #293495;


  // &:hover {
  //   color: #293495;
  // }
`;

// Styling for the custom options panel
const OptionsPanelo = styled.div`
  position: absolute;
  top: 30px;
  right: 0;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 150px;
  z-index: 10;
`;

// Individual option items
const OptionItemo = styled.div`
  padding: 10px;
  cursor: pointer;
  text-align: left;
  &:hover {
    background-color: #f1f1f1;
  }
`;
const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 320px;
  height: 40px;
  border-bottom: 2px solid #2B3497;
  font-size: 14px;
  color: #000;
  margin: 1px auto 20px auto; /* center and add space below */

  span {
    font-weight: bold;
    margin-right: 5px;
  }
`;

const ISDSelect = styled.select`
   width: 80px;
  background-color: transparent;
  height: 40px;
  font-size: 14px;
  border: none;
  outline: none;
  text-align: center;
  color: #000;
  cursor: pointer;
`;

const StyledInput = styled.input`
  flex: 1;
  height: 100%;
  font-size: 14px;
  background: transparent;
  border: none;
  outline: none;
  text-align: left;
  padding-left: 8px; /* small gap between select and input */
  &::placeholder {
    color: #000;
  }
`;

const StyledLabel = styled.label`
  display: inline-block;
  margin: 6px;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.2s all ease;

  input {
    margin-right: 8px;
  }

  &:hover {
    border-color: #888;
  }

  &.active {
    color: #007bff;
  }
`;


const Dashboard = ({ }) => {
  const [iconShow, setIconShow] = useState(false);
  const location = useLocation();
  const [vehicleNo, setVehicleno] = useState('');
  const [meetingOn, setMeetingon] = useState('');
  const [meetingTo, setMeetingto] = useState('');
  const [gate, setGate] = useState('');
  const [building, setBuilding] = useState('');
  const [purpose, setPurpose] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupC, setShowPopupC] = useState(false);
  const [showPopupSuc, setshowPopupSuc] = useState(false);
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [isPopupVisibleMobile, setPopupVisibleMobile] = useState(false);
  const [isPopupVisibleOut, setPopupVisibleOut] = useState(false);

  const [qrumber, setQrNumber] = useState('');
  const [loading, setLoading] = useState(false); // State to manage loader visibility
  // const { roleName } = location.state || {};
  const roleName = localStorage.getItem('selectedRole');
  const [searchQuery, setSearchQuery] = useState('');
  const [qrPopupScreen, setQrPopupScreen] = useState(false);
  const { menuMappings } = useOutletContext();
  const [filteredGateOptions, setFilteredGateOptions] = useState([]);
  const [filteredEntityOptions, setFilteredEntityOptions] = useState([]);
  const employeeId = localStorage.getItem('employeeId');
  const selectedRoleId = localStorage.getItem('selectedRoleId');

  const hasDashboardCheckInOut = menuMappings.some(
    item =>
      item.txtAction === "Dashboard" &&
      item.actionList === "CheckIn/Out"
  );

  // console.log("roleName", roleName);
  useEffect(() => {
    if (roleName !== "Gate Reception") {
      setIconShow(false);
    } else {
      setIconShow(true); // or whatever logic you want for other roles
    }
    if (roleName == "Gate Reception") {
      setIconShow(true); // or whatever logic you want for other roles
    }
  }, [roleName]);
  const [idProofTypes, setIdProofTypes] = useState([]);

  useEffect(() => {
    const getIdProofTypes = async () => {
      try {
        const types = await fetchIdProofTypes();
        setIdProofTypes(types);
      } catch (error) {
        console.error('Error fetching visitor types:', error);
      }
    };

    getIdProofTypes();
  }, []);

  const navigate = useNavigate();
  const [cardCounts, setCardCounts] = useState({
    expectedVisitors: 0,
    checkedIn: 0,
    inPremises: 0,
    crossedDeadlines: 0,
    upcomingDeadlines: 0,
    checkedOut: 0,
  });

  const [lineChartData, setLineChartData] = useState({
    labels: [],
    datasets: [
      {
        label: 'Checkin',
        data: [],
        borderColor: '#293495',
        backgroundColor: 'rgba(41, 52, 149, 0.2)',
        fill: true,
      },
      {
        label: 'Checkout',
        data: [],
        borderColor: '#FFA500',
        backgroundColor: 'rgba(255, 165, 0, 0.2)',
        fill: true,
      },
    ],
  });

  const [barChartData, setBarChartData] = useState({
    labels: [],
    datasets: [
      {
        label: 'Counts',
        data: [],
        backgroundColor: '#293495',
      },
    ],
  });

  useEffect(() => {
    const role = localStorage.getItem('selectedRole');
    //console.log("selected Role :", role);
    const fetchCardCounts = async () => {
      try {
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;
        let locationID = localStorage.getItem('selectedLocationId');
        const locationId = roleName === "Gate Reception" 
        ?  locationID
        : 0;

      const response = await axios.get(`${API_BASE_URL}/Dashboard/${0},${0},${locationId}`);
      if(locationID > 0){
        const entitiesByLocationId =  await axios.post(`/Entity/GetEntityByLocationId/${locationID}`);
        const gatesByLocationId = await axios.get(`/Location/GetBuildingsByLocation?locationID=${locationID}`);
        setFilteredEntityOptions(entitiesByLocationId.data?.data ?? entitiesByLocationId.data ?? []);
        setFilteredGateOptions(gatesByLocationId.data ? gatesByLocationId.data : []);
      }
        const data = response?.data;
        setCardCounts({
          expectedVisitors: data.expectedCount,
          checkedIn: data.checkedin,
          inPremises: data.inPremises,
          crossedDeadlines: data.crossed,
          upcomingDeadlines: data.udCount,
          checkedOut: data.checkedout,
        });
      } catch (error) {
        console.error('Error fetching card counts:', error);
      }
      const getNationality = async () => {
        try {
          const nation = await fetchNationality();
          setNationalityList(nation);

          const defaultNation = nation.find((item) => item.isDefault);
          if (defaultNation) {
            setDefaultNationalityCode(defaultNation.nationalityCode);
          }
        } catch (error) {
          console.error("Error fetching nationalities:", error);
        }
      };

      getNationality();
    };

    const fetchMonthCounts = async () => {
      try {
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

        const responseMonth = await axios.get(`${API_BASE_URL}/VisitorDetails/GetVisitorVIPDetails/${0},${0}`);
        const data = responseMonth.data;

        const labels = data.map(item => item.onDay);
        const checkinData = data.map(item => parseInt(item.checkin, 10));
        const checkoutData = data.map(item => parseInt(item.checkout || 0, 10)); // Handle empty checkout values

        setLineChartData({
          labels: labels,
          datasets: [
            {
              label: 'Checked-In',
              data: checkinData,
              borderColor: '#293495',
              backgroundColor: 'rgba(41, 52, 149, 0.2)',
              fill: true,
              tension: 0.4, // Smooth curves
            },
            {
              label: 'Checked-Out',
              data: checkoutData,
              borderColor: '#FFA500',
              backgroundColor: 'rgba(255, 165, 0, 0.2)',
              fill: true,
              tension: 0.4, // Smooth curves

            },
          ],
        });
      } catch (error) {
        console.error('Error fetching month counts:', error);
      }
    };



    const fetchChartData = async () => {
      try {
        const today = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

        const responseChart = await axios.get(`${API_BASE_URL}/VisitorDetails/GetFVMSCheckInVisitor/${today},${0},${0},${0}`);
        const chartData = responseChart.data;

        const labels = chartData.map(item => item.onTime);
        const data = chartData.map(item => parseInt(item.visitors, 10));

        setBarChartData({
          labels: labels,
          datasets: [
            {
              label: 'Counts',
              data: data,
              backgroundColor: '#293495',
            },
          ],
        });
      } catch (error) {
        console.error('Error fetching Chart counts:', error);
      }
    };

    fetchCardCounts();
    fetchChartData();
    fetchMonthCounts();
  }, []);

  // Array of background colors for the cards
  const cardBackgroundColors = [
    '#ffbb00', // Expected Visitors
    '#7FBA00', // Checked-In
    '#228B22', // Crossed Deadline
    '#F25022', // In-Premises
    '#FF6E00', // Upcoming Deadlines
    '#00A4EF'  // Checked-Out
  ];

  const handleCardClick = async (cardName) => {
    setMobileNumber('')
    setcardData(cardName)
    if (cardName == "QR Checkin/Checkout") {
      setShowTable(false); // Show table on card click
      setPopupVisibleMobile(false)
      setPopupVisible(true)
      return
    }
    if (cardName == "Walk-in Check-in") {
      setPopupVisible(false)
      setShowTable(false); // Show table on card click
      setPopupVisibleMobile(true)
      return
    }
    setPopupVisible(false)
    setPopupVisibleMobile(false)

    setShowTable(true); // Show table on card click
    setErrorMessage(''); // Clear previous error message
    setCurrentPage(1);



    setcardData(cardName)
    setShowTableFilter(false);

    if (cardName == "expected Visitors") {
      setLoading(true);
      if (roleName !== "Gate Reception") {
        setIconShow(false); // or whatever logic you want for other roles
      }
      else {
        setIconShow(true); // or whatever logic you want for other roles

      }
      setIcon(faMobileAlt)


      //console.log("API should call");
      try {
        // const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${1}`);
        const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;
        const entityID = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationID = selectedLocationId !== undefined ? selectedLocationId : 0;
        const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${1},${gateId},${entityID},${locationID}`);

        //console.log("response", response);
        setTableData(response.data.details)
      } catch (error) {
        console.error('Error submitting form:', error);
        setErrorMessage('No visitors to display'); // Set error message if API call fails
        setTableData([]);
        toast.error("No visitors to display")
      } finally {
        setLoading(false); // Hide loader
      }

    } else if (cardName == 'checked In') {
      setLoading(true);
      if (roleName !== "Gate Reception") {
        setIconShow(false); // or whatever logic you want for other roles
      }
      else {
        setIconShow(true); // or whatever logic you want for other roles

      }
      setIcon(faMobileAlt)

      try {
        const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;
        const entityID = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationID = selectedLocationId !== undefined ? selectedLocationId : 0;
        const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${2},${gateId},${entityID},${locationID}`);
        //console.log("response", response);
        setTableData(response.data.details)
      } catch (error) {
        console.error('Error submitting form:', error);
        setErrorMessage('No visitors to display');
        toast.error("No visitors to display")// Set error message if API call fails
        setTableData([]);

      } finally {
        setLoading(false); // Hide loader
      }

    } else if (cardName == 'crossed Deadlines') {
      setLoading(true);
      if (roleName !== "Gate Reception") {
        setIconShow(false); // or whatever logic you want for other roles
      }
      else {
        setIconShow(true); // or whatever logic you want for other roles

      }
      setIcon(faMobileAlt)

      try {
        const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;
        const entityID = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationID = selectedLocationId !== undefined ? selectedLocationId : 0;
        const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${4},${gateId},${entityID},${locationID}`);
        //console.log("response", response);
        setTableData(response.data.details)
      } catch (error) {
        console.error('Error submitting form:', error);
        setErrorMessage('No visitors to display');
        toast.error("No visitors to display") // Set error message if API call fails
        setTableData([]); // Clear table data

      }
      finally {
        setLoading(false); // Hide loader
      }

    } else if (cardName == 'upcoming Deadlines') {
      setLoading(true);
      if (roleName !== "Gate Reception") {
        setIconShow(false); // or whatever logic you want for other roles
      }
      else {
        setIconShow(true); // or whatever logic you want for other roles

      }
      setIcon(faMobileAlt)

      try {
        const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;
        const entityID = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationID = selectedLocationId !== undefined ? selectedLocationId : 0;

        const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${5},${gateId},${entityID},${locationID}`);
        //console.log("response", response);
        setTableData(response.data.details)

      } catch (error) {
        console.error('Error submitting form:', error);
        setErrorMessage('No visitors to display'); // Set error message if API call fails
        toast.error("No visitors to display") // Set error message if API call fails
        setTableData([]); // Clear table data

      }
      finally {
        setLoading(false); // Hide loader
      }

    } else if (cardName == 'checked Out') {
      setLoading(true);
      setIconShow(false);
      try {
        const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;
        const entityID = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationID = selectedLocationId !== undefined ? selectedLocationId : 0;

        const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${6},${gateId},${entityID},${locationID}`);
        //console.log("response", response);
        setTableData(response.data.details)
      } catch (error) {
        console.error('Error submitting form:', error);
        setErrorMessage('No visitors to display'); // Set error message if API call fails
        toast.error("No visitors to display") // Set error message if API call fails
        setTableData([]); // Clear table data

      }
      finally {
        setLoading(false); // Hide loader
      }

    } else if (cardName == 'in Premises') {
      setLoading(true);
      if (roleName !== "Gate Reception") {
        setIconShow(false); // or whatever logic you want for other roles
      } else {
        setIconShow(true); // or whatever logic you want for other roles
      }
      setIcon(faMobileAlt)

      try {
        const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;
        const entityID = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationID = selectedLocationId !== undefined ? selectedLocationId : 0;
        const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${3},${gateId},${entityID},${locationID}`);
        //console.log("response", response);
        setTableData(response.data.details)

      } catch (error) {
        console.error('Error submitting form:', error);
        setErrorMessage('No visitors to display'); // Set error message if API call fails
        toast.error("No visitors to display") // Set error message if API call fails
        setTableData([]); // Clear table data

      }
      finally {
        setLoading(false); // Hide loader
      }

    }
  };
  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const handleClosePopupC = () => {
    setShowPopupC(false);

  };
  const closePopup = () => {
    setPopupVisible(false); // Close the popup
    setPopupVisibleMobile(false); // Close the popup
    setSelected('number');
    setSelectedIdProofTypeId('')
    setIdProof('')
    setMobileNumber('')
    const defaultNation = nationalityList.find((item) => item.isDefault);
    if (defaultNation) {
      setDefaultNationalityCode(defaultNation.nationalityCode);
    }

  };
  const closePopupOut = () => {
    setPopupVisibleOut(false); // Close the popup
  };
  const handleClosePopupSuc = () => {
    setshowPopupSuc(false); // Close the popup
  };
  const handleInputQrChangeN = (e) => {
    const input = e.target.value; // Removes all spaces from the input
    setQrNumber(input);
  };

  const handleInputQrChange = (event) => {
    const input = event.target.value;
    if (input.includes("Visitor Name:")) {
      // Extract the first segment before "Visitor Name:"
      const extractedData = input.split("Visitor Name:")[0].trim();

      // Update the input field with the extracted data
      setQrNumber(extractedData);
    } else {
      // If the input is manual, update it as-is
      setQrNumber(input);
    }  // Update the state with input value
  };

  const [qrPopupData, setQrPopupData] = useState();
  //console.log("Qr Popup Data", qrPopupData)

  const handleNextButtonQRClick = async () => {

    //console.log("QRNumber", qrumber);
    try {
      if (!qrumber.trim()) {
        toast.error("Please scan or enter a QR code.");
        return;
      }

      setLoading(true);
      const response = await axios.get(`/VisitorDetails/DecryptQR?qrCode=${qrumber}`);
      //console.log("QR", response.data);
      if (!response.data) {
        toast.error("Invalid QR code. Please try again.");
        return;
      }

      const { appointmentType, id, passType } = response.data;
      //console.log("Decrypted ID:", id);
      //console.log("Decrypted appointmentType:", appointmentType);
      //console.log("Decrypted passType:", passType);

      //  Step 2: Handle Different QR Types

      // Case A: Appointment - Single
      if (passType === "Appointment" && appointmentType === "Individual") {
        const resp = await axios.get(`/Appointment/GetAppointmentDetailsById/${id}`);

        if (resp.data === "You are not allowed to check-in this visitortype, Please contact administrator.") {
          toast.error("You are not allowed to check-in this visitor type. Please contact administrator.");
        } else if (resp.data?.message === "Visitor blacklisted") {
          toast.error("Visitor blacklisted");
        } else if (resp.data?.appointmentstatus === "Checked-In") {
          toast.error("Visitor has already checked in.");
        } else if(resp?.data?.statusCode !== 0 && resp?.data?.message){
          toast.error(resp?.data?.message);
          return;
        }else {
          navigate("/layout/check-visitoriForm", {
            state: { checkType: "WQ", data: resp.data },
          });
          toast.success("Single visitor check-in successful.");
        }
      } // Case B: Appointment - Group
      else if (passType === "Appointment" && (appointmentType === "Group(L)" || appointmentType === "Group(M)")) {
        const resp = await axios.get(`/GroupAppointment/GetGroupAppointmentDetailsById/${id}`);

        if (resp.data === "You are not allowed to check-in this visitortype, Please contact administrator.") {
          toast.error("You are not allowed to check-in this visitor type. Please contact administrator.");
        } else if (resp.data?.message === "Visitor blacklisted") {
          toast.error("Visitor blacklisted");
        } else if (resp.data?.appointmentstatus === "Checked-In") {
          toast.error("Visitor has already checked in.");
        } else if (resp.data?.message === "Appointment is not scheduled for this mobile number") {
          toast.error("Appointment is not scheduled for this mobile number");
        } else if(resp?.data?.statusCode !== 0 && resp?.data?.message){
          toast.error(resp?.data?.message);
          return;
        }else {
          navigate("/layout/group-CheckIn-form", {
            state: { data: resp.data, checkType: "WQ", GroupType: resp.data.isGroupLeader },
          });
          toast.success("Group visitor check-in successful.");
        }
      }
      else if (passType === "CheckIn" && appointmentType === "WalkIn" || appointmentType === "Individual") {
        const resp = await axios.get(`/VisitorDetails/${id}`);
        //console.log("walkin checkin", resp)
        setQrPopupData({
          ...resp.data,
          appointmentType,
          checkOutType: 'WQ'
        });
        setQrPopupScreen(true);

      }
      else if (passType === "CheckIn" && (appointmentType === "Group(L)" || appointmentType === "Group(M)")) {
        const resp = await axios.get(`/GroupCheckIn/${id}`);
        //console.log("Group checkin", resp)
        setQrPopupData({
          ...resp.data,
          appointmentType,
          checkOutType: 'WQ'
        });
        setQrPopupScreen(true);

      }



      else {
        toast.error("Invalid or unsupported QR code type.");
      }

    } catch (error) {

      console.error('Error fetching appointment details:', error);
      // Handle error scenarios
    }
    finally {
      setLoading(false);
      setPopupVisible(false);
      setQrNumber("");
    }
  }


  const fetchCardCounts = async () => {
    try {
      const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

      const response = await axios.get(`${API_BASE_URL}/Dashboard/${0},${0},${0}`);
      const data = response.data;
      setCardCounts({
        expectedVisitors: data.expectedCount,
        checkedIn: data.checkedin,
        inPremises: data.inPremises,
        crossedDeadlines: data.crossed,
        upcomingDeadlines: data.udCount,
        checkedOut: data.checkedout,
      });
    } catch (error) {
      console.error('Error fetching card counts:', error);
    }
  };
  const CheckedOut = async (data) => {
    //console.log("checked Out Data", data)
    try {
      if (data?.appointmentType === "WalkIn" || data?.appointmentType === "Individual") {

        const resp = await axios.get(`/VisitorDetails/GetVisitorDetailsByCheckInId/${data?.checkInId}`, {
          params: { CheckOutType: data?.checkOutType } // or your variable
        })

        //console.log("Checked Out response", resp)
        if (resp?.data?.statusCode === 0) {
          toast.success(resp?.data?.message)
        } else {
          toast.error(resp?.data?.message)
        }

      }
      else if (data?.appointmentType === "Group(L)" || data?.appointmentType === "Group(M)") {

        const resp = await axios.get(`/GroupCheckIn/GetGroupCheckInDetailsByCheckInId/${data?.checkInId}`, {
          params: { CheckOutType: data?.checkOutType } // or your variable
        })

        //console.log("Checked Out response", resp)
        if (resp?.data?.statusCode === 0) {
          toast.success(resp?.data?.message)
        } else {
          toast.error(resp?.data?.message)
        }
      }
      else if (data?.source === "Walk-In" || data?.source === "Individual") {

        const resp = await axios.get(`/VisitorDetails/GetVisitorDetailsByCheckInId/${parseInt(data.appointmentId, 10)}`, {
          params: { CheckOutType: data?.checkOutType } // or your variable
        })

        //console.log("Checked Out response", resp)
        if (resp?.data?.statusCode === 0) {
          toast.success(resp?.data?.message)
          fetchCardCounts();
          handleCardClick(cardData);
        } else {
          toast.error(resp?.data?.message)
        }
      }
      else if (data?.source === "Group") {

        const resp = await axios.get(`/GroupCheckIn/GetGroupCheckInDetailsByCheckInId/${parseInt(data.appointmentId, 10)}`, {
          params: { CheckOutType: data?.checkOutType } // or your variable
        })

        //console.log("Checked Out response", resp)
        if (resp?.data?.statusCode === 0) {
          toast.success(resp?.data?.message)
          fetchCardCounts();
          handleCardClick(cardData);
        } else {
          toast.error(resp?.data?.message)
        }
      }

      else {
        toast.error("The Appointment type was not found")

      }
    } catch (error) {
      console.log(error);
    }
    fetchCardCounts();
    setQrPopupScreen(false);
    setQrPopupData({});

  }

  const handleNextButtonWalkingCheckinIDProof = async () => {

    if (idProof.trim() === "") {
      toast.error("Please enter the ID Proof number");
      return;
    }
    if (selectedIdProofTypeId == "") {
      toast.error("Please select the ID Proof Type");
      return;
    }

    try {
      // const blackListCheck = await axios.get(`/BlackList/${formattedMobileNumber}`)

      // if (blackListCheck.data) {
      //   toast.error("Person with this mobile number is blacklisted");
      // }
      // else {
      //  const response = await axios.get(`/Appointment/Appointments/${formattedMobileNumber}`)
      // if (response.data == "You are not allowed to check-in this visitortype, Please contact administrator.") {
      //   toast.error("You are not allowed to check-in this visitortype, Please contact administrator.")
      //   return
      // }
      // if (response.data.message == "Visitor blacklisted") {
      //   toast.error("Visitor blacklisted")
      //   return
      // }

      // if (!response) return;
      // console.log("CheckValue", response);

      localStorage.setItem('idProof', idProof);
      const responseN = await axios.get(`/VisitorDetails/GetVisitorDetailsByIdProof?IdProof=${idProof}`);
      const data = responseN.data;
      const dataN = responseN.data;

      if (responseN.data.messageToVisitor == "Visitor details not found.") {
        const idProofNew = idProof
        //console.log("idProof", idProofNew);

        navigate('/layout/walkin-check-in', { state: { checkType: "WID", data, idProof, selectedIdProofTypeId, dataN } });
        return
      }
      if (responseN.data.messageToVisitor == "Allow visitor to Walkin Checkin") {
        const idProofNew = idProof
        //console.log("idProof", idProofNew);

        navigate('/layout/walkin-check-in', { state: { checkType: "WID", data, idProof, dataN, selectedIdProofTypeId } });
        return
      }
      if (responseN.data.messageToVisitor == "Visitor is blacklisted.") {
        toast.error("Visitor is blacklisted")
        return
      }
      //console.log('appointment details with mobile validation:', responseN.data);
      localStorage.setItem('vehicleNo', data.vehicleNo || '');
      localStorage.setItem('meetingOn', data.meetingOn || '');
      localStorage.setItem('meetingTo', data.meetingTo || '');
      localStorage.setItem('gate', data.gate || '');
      localStorage.setItem('building', data.building || '');
      localStorage.setItem('purpose', data.purpose || '');



      //console.log('vehicle', data.vehicleNo);
      //console.log('meetingOn', data.meetingOn);
      //console.log('meetingTo', data.meetingTo);
      //console.log('gate', data.gate);
      //console.log('building', data.building);
      //console.log('purpose', data.purpose);

      // You can also set the state here if needed
      setVehicleno(data.vehicleNo || '');
      setMeetingon(data.meetingOn || '');
      setMeetingto(data.meetingTo || '');
      setGate(data.gate || '');
      setBuilding(data.building || '');
      setPurpose(data.purpose || '');

      // Update state or perform other actions based on the response

      if (responseN.data.messageToVisitor == "Please fill the Visitor Form which received in the mail") {
        toast.error("Please fill the Visitor Form which received in the mail")
        return;
      }
      if (responseN.data.messageToVisitor == "Visitor already checked in.") {
        toast.success("Visitor Already Checked In")
        setSelectedIdProofTypeId('')
        setIdProof('')
        // setShowPopup(true)
        // setMobileNumber('')
        return
      }
      if (responseN.data) {
        // Fetch the latest card counts from the API
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

        const dashboardResponse = await axios.get(`${API_BASE_URL}/Dashboard/${0}`);
        // Update the card counts based on the API response
        setCardCounts({
          mobileCheckInCount: dashboardResponse.data.wmChkin,
        });

        navigate('/layout/check-visitoriForm', { state: { checkType: "WID", data, code: defaultNationalityCode } });

      }

      // if(response.status == 200) {
      //   const responseN = await axios.get(`/VisitorDetails/GetVisitorDetailsPrePopluate?VisitorMob=${mobileNumber}`);
      //   
      // }



      //   if(responseVisitorDeatils.data.checkinType == "WM" && responseVisitorDeatils.data.checkOutType !== "OUT       "){
      //     setShowPopup(true)
      //     return
      //   }

      // if(response.status == 204) {
      //   const mobilenumberNew = mobileNumber
      //   //console.log("mobilenumberNew",mobilenumberNew);

      //   navigate('/layout/walkin-check-in', { state: { checkType: "WM", data,mobilenumberNew } });

      // }

      //}

    } catch (error) {
      console.error('Error fetching appointment details:', error);
      // Handle error scenarios
    }



  };

  const handleNextButtonWalkingCheckin = async () => {

    if (mobileNumber.trim() === "") {
      toast.error("Please enter the mobile number");
      return;
    }
    if (!defaultNationalityCode) {
      toast.error("Please select the nationality");
      return;
    }
    const formattedMobileNumber = `${defaultNationalityCode}-${mobileNumber}`;
    try {
      // const blackListCheck = await axios.get(`/BlackList/${formattedMobileNumber}`)

      // if (blackListCheck.data) {
      //   toast.error("Person with this mobile number is blacklisted");
      // }
      // else {
      // const response = await axios.get(`/Appointment/Appointments/${formattedMobileNumber}`)
      // if (response.data == "You are not allowed to check-in this visitortype, Please contact administrator.") {
      //   toast.error("You are not allowed to check-in this visitortype, Please contact administrator.")
      //   return
      // }
      // if (response.data.message == "Visitor blacklisted") {
      //   toast.error("Visitor blacklisted")
      //   return
      // }

      // if (!response) return;
      // console.log("CheckValue", response);

      localStorage.setItem('mobileNumber', mobileNumber);
      const responseN = await axios.get(`/VisitorDetails/GetVisitorDetailsByVisitorMobileAndVisitorTypeId?visitorMobile=${formattedMobileNumber}`);
      const data = responseN.data;
      const dataN = responseN.data;

      if (responseN.data == "You are not allowed to check-in this visitortype, Please contact administrator.") {
        toast.error("You are not allowed to check-in this visitortype, Please contact administrator.")
        return
      }
      if (responseN.data.messageToVisitor == "Visitor is blacklisted.") {
        toast.error("Visitor is blacklisted")
        return
      }


      if (responseN.data.messageToVisitor == "Nationality code does not match") {
        toast.error("Nationality code does not match")
        return
      }
      if (responseN.data.messageToVisitor == "Visitor details not found") {
        const mobilenumberNew = mobileNumber
        //console.log("mobilenumberNew", mobilenumberNew);

        navigate('/layout/walkin-check-in', { state: { checkType: "WM", data, mobilenumberNew, defaultNationalityCode, dataN } });
        return
      }
      if (responseN.data.messageToVisitor == "Allow visitor to Walkin Checkin") {
        const mobilenumberNew = mobileNumber
        //console.log("mobilenumberNew", mobilenumberNew);

        navigate('/layout/walkin-check-in', { state: { checkType: "WM", data, mobilenumberNew, defaultNationalityCode, dataN } });
        return
      }
      //  //console.log('appointment details with mobile validation:', responseN.data);
      localStorage.setItem('vehicleNo', data.vehicleNo || '');
      localStorage.setItem('meetingOn', data.meetingOn || '');
      localStorage.setItem('meetingTo', data.meetingTo || '');
      localStorage.setItem('gate', data.gate || '');
      localStorage.setItem('building', data.building || '');
      localStorage.setItem('purpose', data.purpose || '');



      //console.log('vehicle', data.vehicleNo);
      //console.log('meetingOn', data.meetingOn);
      //console.log('meetingTo', data.meetingTo);
      //console.log('gate', data.gate);
      //console.log('building', data.building);
      //console.log('purpose', data.purpose);

      // You can also set the state here if needed
      setVehicleno(data.vehicleNo || '');
      setMeetingon(data.meetingOn || '');
      setMeetingto(data.meetingTo || '');
      setGate(data.gate || '');
      setBuilding(data.building || '');
      setPurpose(data.purpose || '');

      // Update state or perform other actions based on the response

      if (responseN.data.messageToVisitor == "Please fill the Visitor Form which received in the mail") {
        toast.error("Please fill the Visitor Form which received in the mail")
        return;
      }
      if (responseN.data.messageToVisitor == "Visitor Already Checked In") {
        toast.success("Visitor Already Checked In")
        // setShowPopup(true)
        setMobileNumber('')
        const defaultNation = nationalityList.find((item) => item.isDefault);
        if (defaultNation) {
          setDefaultNationalityCode(defaultNation.nationalityCode);
        }
        return
      }
      if (responseN.data) {
        // Fetch the latest card counts from the API
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

        const dashboardResponse = await axios.get(`${API_BASE_URL}/Dashboard/${0}`);
        // Update the card counts based on the API response
        setCardCounts({
          mobileCheckInCount: dashboardResponse.data.wmChkin,
        });

        navigate('/layout/check-visitoriForm', { state: { checkType: "WM", data, code: defaultNationalityCode } });

      }

      // if(response.status == 200) {
      //   const responseN = await axios.get(`/VisitorDetails/GetVisitorDetailsPrePopluate?VisitorMob=${mobileNumber}`);
      //   
      // }



      //   if(responseVisitorDeatils.data.checkinType == "WM" && responseVisitorDeatils.data.checkOutType !== "OUT       "){
      //     setShowPopup(true)
      //     return
      //   }

      // if(response.status == 204) {
      //   const mobilenumberNew = mobileNumber
      //   //console.log("mobilenumberNew",mobilenumberNew);

      //   navigate('/layout/walkin-check-in', { state: { checkType: "WM", data,mobilenumberNew } });

      // }

      //}

    } catch (error) {
      console.error('Error fetching appointment details:', error);
      // Handle error scenarios
    }



  };
  function decodeCheckInId(qrcode) {
    // Mapping encoded byte pairs back to digits
    const reverseMapping = {
      "515253": "1",
      "303030": "3",
      "505050": "5",
      "202020": "2",
      "868484": "4",
      "606060": "6",
      "707070": "7",
      "808080": "8",
      "909090": "9",
      "000000": "0"
    };

    let checkInId = '';

    // Loop through the qrcode string in steps of 6 characters (each code is 6 characters long)
    for (let i = 0; i < qrcode.length; i += 6) {
      const segment = qrcode.substring(i, i + 6); // Extract each 6-character segment
      checkInId += reverseMapping[segment]; // Map the segment back to the corresponding digit
    }

    return checkInId; // Return the decoded check-in ID
  }

  const handleNextButtonQRClickOut = async () => {
    if (qrumber == '') {
      toast.error('please enter QR code ')
      return
    }
    //console.log("QrCode", qrumber);
    const decryptedNumber = decodeCheckInId(qrumber);
    //console.log("decryptedNumber", decryptedNumber);
    if (visitorData.source == "Group" || visitorData.source == "GroupMember") {
      try {
        const responseAppointment = await axios.put(`/GroupCheckin/QRCodeCheckOut/${qrumber},${true}`);
        setQrNumber('');
        //console.log(responseAppointment);
        toast.success(responseAppointment.data)
        if (responseAppointment.data) {
          setshowPopupSuc(true);
          setPopupVisibleOut(false);
        }

        setPopupVisibleOut(false);



      } catch (error) {
        console.error('Error fetching appointment details:', error);
        // Handle error scenarios
      }

    }
    else {
      try {
        const responseAppointment = await axios.put(`/VisitorDetails/QRCodeCheckOut/${qrumber},${true}`);
        //console.log(responseAppointment);
        toast.success(responseAppointment.data)
        if (responseAppointment.data) {
          setQrNumber('');
          setshowPopupSuc(true);
        }
        setQrNumber('');
        setPopupVisibleOut(false);

      } catch (error) {
        console.error('Error fetching appointment details:', error);
        // Handle error scenarios
      }

    }
    const fetchCardCounts = async () => {
      try {
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

        const response = await axios.get(`${API_BASE_URL}/Dashboard/${0},${0},${0}`);
        const data = response.data;
        setCardCounts({
          expectedVisitors: data.expectedCount,
          checkedIn: data.checkedin,
          inPremises: data.inPremises,
          crossedDeadlines: data.crossed,
          upcomingDeadlines: data.udCount,
          checkedOut: data.checkedout,
        });
      } catch (error) {
        console.error('Error fetching card counts:', error);
      }
    };
    fetchCardCounts();




  };

  function decryptQRCode(qrCode) {
    let decryptedNumber = '';
    for (let i = 0; i < qrCode.length; i += 2) {
      const asciiValue = qrCode.substring(i, i + 2);
      decryptedNumber += String.fromCharCode(parseInt(asciiValue, 10));
    }

    // Use a regular expression to extract only the digits from the decrypted string
    const mobileNumber = decryptedNumber.match(/\d+/)[0];
    return mobileNumber;
  }
  const [visitorData, setVisitorData] = useState('')
  const handleIconClickQR = async (mobileNumber, cardName, visitor) => {
    //console.log("cardName", cardName);
    setVisitorData(visitor)
    //console.log(mobileNumber);
    if (cardName == 'expected Visitors') {
      const responseN = await axios.get(`/VisitorDetails/GetVisitorDetailsPrePopluate?VisitorMob=${mobileNumber}`);
      if (responseN.data.messageToVisitor == "Please fill the Visitor Form which received in the mail") {
        toast.error("Please fill the Visitor Form which received in the mail")
        return;
      }

      setPopupVisible(true);
    }
    if (cardName == 'checked In' || cardName == 'crossed Deadline' || cardName == 'in Premises' || cardName == 'upcoming Deadlines') {
      setPopupVisibleOut(true);
    }
  }

  const handleIconClick = async (mobileNumber, cardName, visitor, appointmentId, type) => {
    //console.log("cardName", cardName);
    //console.log("visitorTAble", visitor);
    //console.log("type", type)
    const appointmentIdAsInt = await parseInt(appointmentId, 10);
    //console.log(mobileNumber);
    if (cardName == 'expected Visitors') {
      if (visitor?.status === "Visit Booked") {
        toast.error("Please fill the visitor form received via email");
        return
      }
      if (visitor.source == "Group" || visitor.source == "GroupMember") {
        try {
          // const blackListCheck = await axios.get(`/BlackList/${mobileNumber}`)

          // if (blackListCheck.data) {
          //   toast.error("Person with this mobile number is blacklisted");
          //   return
          // }
          //else {

          const isGroupLeader = visitor.source == "Group" ? true : false
          const response = await axios.get(`/GroupAppointment/GetGroupAppointmentDetailsById/${appointmentIdAsInt}`);
          if (response.data == "You are not allowed to check-in this visitortype, Please contact administrator.") {
            toast.error("You are not allowed to check-in this visitortype, Please contact administrator.")
            return
          }
          localStorage.setItem('mobileNumber', mobileNumber);

          if (response.data.message == "Visitor blacklisted") {
            toast.error("Visitor blacklisted")
            return
          }
          else if (response.data.message == "Please fill the visitor form received via email") {
            toast.error("Please fill the visitor form received via email")
            return;
          }

         else if (response.data.message == "Visitor already checked-in") {
            toast.success("Visitor already checked-in")
            return;
          }
          else if (response.data.message == "Appointment is not scheduled for this mobile number") {
            toast.error("Appointment is not scheduled for this mobile number")
            return;
          }

         else if (response.data.statusCode !== 0 && response.data.message) {
            toast.error(response.data.message)
            return;
          }

          if (response.status === 204) {
            setShowPopupC(true);
            return;
          }

          //console.log('appointment details with mobile validation:', response.data);
          const data = response.data;
          localStorage.setItem('vehicleNo', data.vehicleNo || '');
          localStorage.setItem('meetingOn', data.meetingOn || '');
          localStorage.setItem('meetingTo', data.meetingTo || '');
          localStorage.setItem('gate', data.gate || '');
          localStorage.setItem('building', data.building || '');
          localStorage.setItem('purpose', data.purpose || '');



          // console.log('vehicle', data.vehicleNo);
          // console.log('meetingOn', data.meetingOn);
          // console.log('meetingTo', data.meetingTo);
          // console.log('gate', data.gate);
          // console.log('building', data.building);
          // console.log('purpose', data.purpose);

          // You can also set the state here if needed
          setVehicleno(data.vehicleNo || '');
          setMeetingon(data.meetingOn || '');
          setMeetingto(data.meetingTo || '');
          setGate(data.gate || '');
          setBuilding(data.building || '');
          setPurpose(data.purpose || '');

          // Update state or perform other actions based on the response
          if (response.status === 200) {

            navigate('/layout/group-CheckIn-form', { state: { data, checkType: type, GroupType: isGroupLeader } });

          }


          //  }


        } catch (error) {
          console.error('Error fetching appointment details:', error);
          // Handle error scenarios
        }
      } else {
        try {

          const responseN = await axios.get(`/Appointment/GetAppointmentDetailsById/${appointmentIdAsInt}`)
          //console.log("validation Error", responseN);
          if (responseN.data == "You are not allowed to check-in this visitortype, Please contact administrator.") {
            toast.error("You are not allowed to check-in this visitortype, Please contact administrator.")
            return
          }
          if (responseN.data.message == "Visitor blacklisted") {
            toast.error("Visitor blacklisted")
            return
          }
          if(responseN?.data?.statusCode !== 0 && responseN?.data?.message){
            toast.error(responseN?.data?.message);
            return;
          }

          localStorage.setItem('mobileNumber', mobileNumber);
          if (!responseN) return;
          const data = responseN.data;
          //  const responseN = await axios.get(`/VisitorDetails/GetVisitorDetailsPrePopluate?VisitorMob=${mobileNumber}`);
          if (responseN.data.messageToVisitor == "Visitor details not found") {
            const mobilenumberNew = mobileNumber
            //console.log("mobilenumberNew", mobilenumberNew);

            navigate('/layout/walkin-check-in', { state: { checkType: type, data, mobilenumberNew } });
            return
          }
          if (responseN.data.messageToVisitor == "Allow visitor to Walkin Checkin") {
            const mobilenumberNew = mobileNumber
            //console.log("mobilenumberNew", mobilenumberNew);

            navigate('/layout/walkin-check-in', { state: { checkType: type, data, mobilenumberNew } });
            return
          }


          //console.log('appointment details with mobile validation:', responseN.data);
          localStorage.setItem('vehicleNo', data.vehicleNo || '');
          localStorage.setItem('meetingOn', data.meetingOn || '');
          localStorage.setItem('meetingTo', data.meetingTo || '');
          localStorage.setItem('gate', data.gate || '');
          localStorage.setItem('building', data.building || '');
          localStorage.setItem('purpose', data.purpose || '');
          //  localStorage.setItem('appointmentId', appointmentIdAsInt);



          //console.log('vehicle', data.vehicleNo);
          //console.log('meetingOn', data.meetingOn);
          //console.log('meetingTo', data.meetingTo);
          //console.log('gate', data.gate);
          //console.log('building', data.building);
          //console.log('purpose', data.purpose);

          // You can also set the state here if needed
          setVehicleno(data.vehicleNo || '');
          setMeetingon(data.meetingOn || '');
          setMeetingto(data.meetingTo || '');
          setGate(data.gate || '');
          setBuilding(data.building || '');
          setPurpose(data.purpose || '');
          if (responseN.data.messageToVisitor == "Please fill the Visitor Form which received in the mail") {
            toast.error("Please fill the Visitor Form which received in the mail")
            return;
          }
          if (responseN.data.messageToVisitor == "Visitor Already Checked In") {
            toast.success("Visitor Already Checked In")
            return;
          }

          // Update state or perform other actions based on the response
          if (responseN.data) {
            // Fetch the latest card counts from the API
            // const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

            // const dashboardResponse = await axios.get(`${API_BASE_URL}/Dashboard/${0},${0}`);

            // // Update the card counts based on the API response
            // setCardCounts({
            //   mobileCheckInCount: dashboardResponse.data.wmChkin,
            // });

            navigate('/layout/check-visitoriForm', { state: { checkType: type, data } });

          }

        } catch (error) {
          console.error('Error fetching appointment details:', error);
          // Handle error scenarios
        }

      }

    }
    if (cardName == 'checked In' || cardName == 'crossed Deadline' || cardName == 'in Premises' || cardName == 'upcoming Deadlines') {

      if (visitor.source == 'Group' || visitor.source == "GroupMember") {
        try {

          const responseAppointment = await axios.get(`/GroupCheckIn/GroupCheckIn/${mobileNumber}`);
          //console.log('Checkout Appointment API:', responseAppointment.data);
          if (responseAppointment.data.checkOutType === "OUT       ") {
            setShowPopup(true);
            return;
          }
          if (responseAppointment.data) {
            const responsev = await axios.get(`/GroupAppointment/GroupAppointment/${mobileNumber}`);
            if (responsev.data == "You are not allowed to check-in this visitortype, Please contact administrator.") {
              toast.error("You are not allowed to check-in this visitortype, Please contact administrator.")
              return
            }


            const responseVisitorDeatils = await axios.put(`/GroupCheckIn/${mobileNumber}`);
            //console.log("responseVisitorDeatils", responseVisitorDeatils.data);

            const AppId = responseAppointment.data.groupAppointmentId
            //console.log("AppId", AppId);
            const Stat = "OUT"
            //console.log("Stat", Stat);
            const updateAppoinmentStatus = await axios.post(`/GroupAppointment/AppointStatusUpd/${AppId},${Stat}`);
            // if(updateAppoinmentStatus.data ="All Group members not checked-in"){

            // }
            setshowPopupSuc(true)
            //console.log('update GroupAppointment API:', updateAppoinmentStatus);
            const empID = localStorage.getItem('employeeId');
            const getManagerDetails = await axios.get(`/Employee/${empID}`);
            // const updatedFormData = {
            //   VisitorName: responseAppointment.data.visitorName,
            //   MailSubject: 'Visitor CheckOut Notification',
            //   MailType: 'CHKOUTVISITOR',
            //   MeetingOn: responseAppointment.data.checkInDateTime,
            //   VisitorMobile: responseAppointment.data.visitorMobile,
            //   MeetingVenue: responseAppointment.data.meetingvenue || '',
            //   txtManagersID: null,
            //   ManagerMail: getManagerDetails.data.managerMailID,
            //   SecsEmailId: null,
            //   VisitorCompany: responseAppointment.data.visitorCompany,
            //   HostName: responseAppointment.data.hostName,
            //   ToAddress: responseAppointment.data.hostEmail,
            // }
            // const updatedFormDatav = {
            //   VisitorName: responseAppointment.data.visitorName,
            //   MailSubject: 'Visitor CheckOut Notification',
            //   MailType: 'CHKOUTVISITOR',
            //   MeetingOn: responseAppointment.data.checkInDateTime,
            //   VisitorMobile: responseAppointment.data.visitorMobile,
            //   MeetingVenue: responseAppointment.data.meetingvenue || '',
            //   txtManagersID: null,
            //   ManagerMail: getManagerDetails.data.managerMailID,
            //   SecsEmailId: null,
            //   VisitorCompany: responseAppointment.data.visitorCompany,
            //   HostName: responseAppointment.data.hostName,
            //   ToAddress: responsev.data.visitorEmail,
            // }
            // console.log("updatedFormData", updatedFormData);
            // const updateMail = await axios.post('/Mail', updatedFormData);
            // const updateMailv = await axios.post('/Mail', updatedFormDatav);

            // console.log("updateMail", updateMail);
            const sendSmsData = {
              AppointmentDtTm: responseAppointment.data.checkInDateTime,
              AppointmentVenue: responseAppointment.data.meetingvenue || '',
              ContactNo: "+91" + responseAppointment.data.hostMobile,
              HostName: responseAppointment.data.hostName,
              SMSType: "MsgToHostCHKOUT",
              VisitorName: responseAppointment.data.visitorName
            }
            // console.log("sendSmsData", sendSmsData);
            // const updateSendSms = await axios.post('/SendSMS', sendSmsData);
            // console.log("updateSendSms", updateSendSms);
          }
          const fetchCardCounts = async () => {
            try {
              const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

              const response = await axios.get(`${API_BASE_URL}/Dashboard/${0},${0},${0}`);
              const data = response.data;
              setCardCounts({
                expectedVisitors: data.expectedCount,
                checkedIn: data.checkedin,
                inPremises: data.inPremises,
                crossedDeadlines: data.crossed,
                upcomingDeadlines: data.udCount,
                checkedOut: data.checkedout,
              });
            } catch (error) {
              console.error('Error fetching card counts:', error);
            }
          };

          const fetchMonthCounts = async () => {
            try {
              const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

              const responseMonth = await axios.get(`${API_BASE_URL}/VisitorDetails/GetVisitorVIPDetails/${0},${0}`);
              const data = responseMonth.data;

              const labels = data.map(item => item.onDay);
              const checkinData = data.map(item => parseInt(item.checkin, 10));
              const checkoutData = data.map(item => parseInt(item.checkout || 0, 10)); // Handle empty checkout values

              setLineChartData({
                labels: labels,
                datasets: [
                  {
                    label: 'Checked-In',
                    data: checkinData,
                    borderColor: '#293495',
                    backgroundColor: 'rgba(41, 52, 149, 0.2)',
                    fill: true,
                    tension: 0.4, // Smooth curves
                  },
                  {
                    label: 'Checked-Out',
                    data: checkoutData,
                    borderColor: '#FFA500',
                    backgroundColor: 'rgba(255, 165, 0, 0.2)',
                    fill: true,
                    tension: 0.4, // Smooth curves

                  },
                ],
              });
            } catch (error) {
              console.error('Error fetching month counts:', error);
            }
          };



          const fetchChartData = async () => {
            try {
              const today = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format
              const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

              const responseChart = await axios.get(`${API_BASE_URL}/VisitorDetails/GetFVMSCheckInVisitor/${today},${0},${0}`);
              const chartData = responseChart.data;

              const labels = chartData.map(item => item.onTime);
              const data = chartData.map(item => parseInt(item.visitors, 10));

              setBarChartData({
                labels: labels,
                datasets: [
                  {
                    label: 'Counts',
                    data: data,
                    backgroundColor: '#293495',
                  },
                ],
              });
            } catch (error) {
              console.error('Error fetching Chart counts:', error);
            }
          };
          fetchCardCounts();
          fetchChartData();
          fetchMonthCounts();



        } catch (error) {
          console.error('Error fetching appointment details:', error);
          // Handle error scenarios
        }
      } else {
        try {

          const responseAppointment = await axios.get(`/Appointment/Appointments/${mobileNumber}`)
          //console.log("validation Error", responseAppointment);
          if (responseAppointment.data == "You are not allowed to check-in this visitortype, Please contact administrator.") {
            toast.error("You are not allowed to check-in this visitortype, Please contact administrator.")
            return
          }
          if (responseAppointment.data.message == "Visitor blacklisted") {
            toast.error("Visitor blacklisted")
            return

          }
          //console.log('Checkout Appointment API:', responseAppointment.data);
          if (responseAppointment.data.appointmentstatus === "Scheduled") {
            toast.error("Check in is not  done for the visitors")
            return;
          }
          if (responseAppointment.data.appointmentstatus === "Checked-Out") {
            setShowPopup(true);
            return;
          }
          else if (responseAppointment.data.appointmentstatus === "Checked-In") {
            const responseVisitorDeatils = await axios.get(`/VisitorDetails/GetVisitorDetailsPrePopluate?VisitorMob=${mobileNumber}`);
            const AppId = responseVisitorDeatils.data.appointmentId
            //console.log("AppId", AppId);
            const Stat = "OUT"
            //console.log("Stat", Stat);
            const updateAppoinmentStatus = await axios.post(`/Appointment/AppointStatusUpd/${AppId},${Stat}`);
            const responseVisitorDeatilsV = await axios.put(`/VisitorDetails/VisitorDetails/${mobileNumber}`);
            setshowPopupSuc(true)
            const fetchCardCounts = async () => {
              try {
                const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

                const response = await axios.get(`${API_BASE_URL}/Dashboard/${0},${0},${0}`);
                const data = response.data;
                setCardCounts({
                  expectedVisitors: data.expectedCount,
                  checkedIn: data.checkedin,
                  inPremises: data.inPremises,
                  crossedDeadlines: data.crossed,
                  upcomingDeadlines: data.udCount,
                  checkedOut: data.checkedout,
                });
              } catch (error) {
                console.error('Error fetching card counts:', error);
              }
            };

            const fetchMonthCounts = async () => {
              try {
                const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

                const responseMonth = await axios.get(`${API_BASE_URL}/VisitorDetails/GetVisitorVIPDetails/${0},${0}`);
                const data = responseMonth.data;

                const labels = data.map(item => item.onDay);
                const checkinData = data.map(item => parseInt(item.checkin, 10));
                const checkoutData = data.map(item => parseInt(item.checkout || 0, 10)); // Handle empty checkout values

                setLineChartData({
                  labels: labels,
                  datasets: [
                    {
                      label: 'Checked-In',
                      data: checkinData,
                      borderColor: '#293495',
                      backgroundColor: 'rgba(41, 52, 149, 0.2)',
                      fill: true,
                      tension: 0.4, // Smooth curves
                    },
                    {
                      label: 'Checked-Out',
                      data: checkoutData,
                      borderColor: '#FFA500',
                      backgroundColor: 'rgba(255, 165, 0, 0.2)',
                      fill: true,
                      tension: 0.4, // Smooth curves

                    },
                  ],
                });
              } catch (error) {
                console.error('Error fetching month counts:', error);
              }
            };



            const fetchChartData = async () => {
              try {
                const today = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format
                const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

                const responseChart = await axios.get(`${API_BASE_URL}/VisitorDetails/GetFVMSCheckInVisitor/${today},${0},${0}`);
                const chartData = responseChart.data;

                const labels = chartData.map(item => item.onTime);
                const data = chartData.map(item => parseInt(item.visitors, 10));

                setBarChartData({
                  labels: labels,
                  datasets: [
                    {
                      label: 'Counts',
                      data: data,
                      backgroundColor: '#293495',
                    },
                  ],
                });
              } catch (error) {
                console.error('Error fetching Chart counts:', error);
              }
            };
            fetchCardCounts();
            fetchChartData();
            fetchMonthCounts();
          }
          if (responseAppointment.data.message === "Appointment is not scheduled for this mobile number") {
            const responseVisitorDeatils = await axios.get(`/VisitorDetails/GetVisitorDetailsPrePopluate?VisitorMob=${mobileNumber}`);
            if (responseVisitorDeatils.data.messageToVisitor == "Nationality code does not match") {
              toast.error("Nationality code does not match")
              return
            }

            //console.log("responseVisitorDeatils", responseVisitorDeatils.data);
            if (responseVisitorDeatils.data.messageToVisitor == "Visitor details not found") {
              toast.error("Visitor details not found")
              return
            }
            else if (responseVisitorDeatils.data.messageToVisitor == "Allow visitor to Walkin Checkin") {
              setShowPopup(true);
              return;

            } else if (responseVisitorDeatils.data.messageToVisitor == "Visitor Already Checked In") {
              const responseVisitorDeatilsV = await axios.put(`/VisitorDetails/VisitorDetails/${mobileNumber}`);
              setshowPopupSuc(true)
              const fetchCardCounts = async () => {
                try {
                  const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

                  const response = await axios.get(`${API_BASE_URL}/Dashboard/${0},${0},${0}`);
                  const data = response.data;
                  setCardCounts({
                    expectedVisitors: data.expectedCount,
                    checkedIn: data.checkedin,
                    inPremises: data.inPremises,
                    crossedDeadlines: data.crossed,
                    upcomingDeadlines: data.udCount,
                    checkedOut: data.checkedout,
                  });
                } catch (error) {
                  console.error('Error fetching card counts:', error);
                }
              };

              const fetchMonthCounts = async () => {
                try {
                  const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

                  const responseMonth = await axios.get(`${API_BASE_URL}/VisitorDetails/GetVisitorVIPDetails/${0},${0}`);
                  const data = responseMonth.data;

                  const labels = data.map(item => item.onDay);
                  const checkinData = data.map(item => parseInt(item.checkin, 10));
                  const checkoutData = data.map(item => parseInt(item.checkout || 0, 10)); // Handle empty checkout values

                  setLineChartData({
                    labels: labels,
                    datasets: [
                      {
                        label: 'Checked-In',
                        data: checkinData,
                        borderColor: '#293495',
                        backgroundColor: 'rgba(41, 52, 149, 0.2)',
                        fill: true,
                        tension: 0.4, // Smooth curves
                      },
                      {
                        label: 'Checked-Out',
                        data: checkoutData,
                        borderColor: '#FFA500',
                        backgroundColor: 'rgba(255, 165, 0, 0.2)',
                        fill: true,
                        tension: 0.4, // Smooth curves

                      },
                    ],
                  });
                } catch (error) {
                  console.error('Error fetching month counts:', error);
                }
              };



              const fetchChartData = async () => {
                try {
                  const today = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format
                  const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

                  const responseChart = await axios.get(`${API_BASE_URL}/VisitorDetails/GetFVMSCheckInVisitor/${today},${0},${0}`);
                  const chartData = responseChart.data;

                  const labels = chartData.map(item => item.onTime);
                  const data = chartData.map(item => parseInt(item.visitors, 10));

                  setBarChartData({
                    labels: labels,
                    datasets: [
                      {
                        label: 'Counts',
                        data: data,
                        backgroundColor: '#293495',
                      },
                    ],
                  });
                } catch (error) {
                  console.error('Error fetching Chart counts:', error);
                }
              };
              fetchCardCounts();
              fetchChartData();
              fetchMonthCounts();
            }
            return;
          }


        } catch (error) {
          console.error('Error fetching appointment details:', error);
          // Handle error scenarios
        }
        // try {

        //   const responseAppointment = await axios.get(`/Appointment/Appointments/${mobileNumber}`);
        //   //console.log('Checkout Appointment API:', responseAppointment.data);
        //   // if(responseAppointment.status == 204) {
        //   //   const responseVisitorDeatils = await axios.get(`/VisitorDetails/VisitorDetails/${mobileNumber}`);
        //   //   if(responseVisitorDeatils.data =="Failed to update") {
        //   //     toast.error('No appointment is scheduled for the entered mobile number.')
        //   //     return
        //   //   }
        //   // }
        //   if (responseAppointment.data.appointmentstatus === "Checked-Out") {
        //     setShowPopup(true);
        //     return;
        //   }
        //   if (responseAppointment.status == 204) {
        //     const responseVisitorDeatils = await axios.get(`/VisitorDetails/GetVisitorDetailsPrePopluate?VisitorMob=${mobileNumber}`);
        //     //console.log('Checkout Visitors API:', responseVisitorDeatils.data);
        //     //console.log('Checkout Visitors API:', responseVisitorDeatils.data.checkOutType);
        //     if (responseVisitorDeatils.data.passReturned === "Y") {
        //       setShowPopup(true);
        //       return;
        //     }
        //     const responseVisitorDeatilsV = await axios.put(`/VisitorDetails/VisitorDetails/${mobileNumber}`);

        //     if (responseVisitorDeatilsV.data == "Failed to update") {
        //       toast.error('No appointment is scheduled for the entered mobile number.')
        //       return
        //     }
        //     setshowPopupSuc(true)


        //     const fetchCardCounts = async () => {
        //       try {
        //         const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

        //         const response = await axios.get(`${API_BASE_URL}/Dashboard/${0}`);
        //         const data = response.data;
        //         setCardCounts({
        //           expectedVisitors: data.expectedCount,
        //           checkedIn: data.checkedin,
        //           inPremises: data.inPremises,
        //           crossedDeadlines: data.crossed,
        //           upcomingDeadlines: data.udCount,
        //           checkedOut: data.checkedout,
        //         });
        //       } catch (error) {
        //         console.error('Error fetching card counts:', error);
        //       }
        //     };

        //     const fetchMonthCounts = async () => {
        //       try {
        //         const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

        //         const responseMonth = await axios.get(`${API_BASE_URL}/VisitorDetails/GetVisitorVIPDetails/${0}`);
        //         const data = responseMonth.data;

        //         const labels = data.map(item => item.onDay);
        //         const checkinData = data.map(item => parseInt(item.checkin, 10));
        //         const checkoutData = data.map(item => parseInt(item.checkout || 0, 10)); // Handle empty checkout values

        //         setLineChartData({
        //           labels: labels,
        //           datasets: [
        //             {
        //               label: 'Checked-In',
        //               data: checkinData,
        //               borderColor: '#293495',
        //               backgroundColor: 'rgba(41, 52, 149, 0.2)',
        //               fill: true,
        //               tension: 0.4, // Smooth curves
        //             },
        //             {
        //               label: 'Checked-Out',
        //               data: checkoutData,
        //               borderColor: '#FFA500',
        //               backgroundColor: 'rgba(255, 165, 0, 0.2)',
        //               fill: true,
        //               tension: 0.4, // Smooth curves

        //             },
        //           ],
        //         });
        //       } catch (error) {
        //         console.error('Error fetching month counts:', error);
        //       }
        //     };



        //     const fetchChartData = async () => {
        //       try {
        //         const today = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format
        //         const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

        //         const responseChart = await axios.get(`${API_BASE_URL}/VisitorDetails/GetFVMSCheckInVisitor/${today},${0}`);
        //         const chartData = responseChart.data;

        //         const labels = chartData.map(item => item.onTime);
        //         const data = chartData.map(item => parseInt(item.visitors, 10));

        //         setBarChartData({
        //           labels: labels,
        //           datasets: [
        //             {
        //               label: 'Counts',
        //               data: data,
        //               backgroundColor: '#293495',
        //             },
        //           ],
        //         });
        //       } catch (error) {
        //         console.error('Error fetching Chart counts:', error);
        //       }
        //     };
        //     fetchCardCounts();
        //     fetchChartData();
        //     fetchMonthCounts();

        //     // if(responseVisitorDeatils.status == 200){
        //     //   setMobileNumber('');
        //     //   setShowPopupSuc(true)
        //     //   return;
        //     // }
        //     return
        //   }
        //   const responseVisitorDeatils = await axios.get(`/VisitorDetails/GetVisitorDetailsPrePopluate?VisitorMob=${mobileNumber}`);
        //   //console.log('Checkout Visitors API:', responseVisitorDeatils.data);
        //   //console.log('Checkout Visitors API:', responseVisitorDeatils.data.checkOutType);
        //   if (responseVisitorDeatils.data.passReturned === "Y") {
        //     setShowPopup(true);
        //     return;
        //   }

        //   if (responseVisitorDeatils.data.passReturned === null || '' || "string") {
        //     //console.log("checkout type is null");
        //     const AppId = responseVisitorDeatils.data.appointmentId
        //     //console.log("AppId", AppId);
        //     const Stat = "OUT"
        //     //console.log("Stat", Stat);

        //     const updateAppoinmentStatus = await axios.post(`/Appointment/AppointStatusUpd/${AppId},${Stat}`);
        //     //console.log('update AppoinmentStatus API:', updateAppoinmentStatus);
        //     const updateResponseVisitorDeatils = await axios.put(`/VisitorDetails/VisitorDetails/${mobileNumber}`);
        //     //console.log('updateResponseVisitorDeatils:', updateResponseVisitorDeatils.data);
        //     const empID = localStorage.getItem('employeeId');
        //     const getManagerDetails = await axios.get(`/Employee/${empID}`);
        //     //console.log("getManagerDetails :", getManagerDetails.data);
        //     // const updatedFormData = {
        //     //   VisitorName: responseVisitorDeatils.data.visitorName,
        //     //   MailSubject: 'Visitor CheckOut Notification',
        //     //   MailType: 'CHKOUTVISITOR',
        //     //   MeetingOn: responseVisitorDeatils.data.meetingOn,
        //     //   VisitorMobile: responseVisitorDeatils.data.visitorMobile,
        //     //   MeetingVenue: responseVisitorDeatils.data.meetingvenue,
        //     //   txtManagersID: null,
        //     //   ManagerMail: getManagerDetails.data.managerMailID,
        //     //   SecsEmailId: null,
        //     //   VisitorCompany: responseVisitorDeatils.data.visitorCompany,
        //     //   HostName: updateResponseVisitorDeatils.data.hostName,
        //     //   ToAddress: responseVisitorDeatils.data.emailId,
        //     // }
        //     // console.log("updatedFormData", updatedFormData);
        //     // const updateMail = await axios.post('/Mail', updatedFormData);
        //     // console.log("updateMail", updateMail);

        //     const sendSmsData = {
        //       AppointmentDtTm: responseAppointment.data.meetingOn,
        //       AppointmentVenue: responseAppointment.data.meetingvenue,
        //       ContactNo: "+91" + updateResponseVisitorDeatils.data.hostMobile,
        //       HostName: updateResponseVisitorDeatils.data.hostName,
        //       SMSType: "MsgToHostCHKOUT",
        //       VisitorName: updateResponseVisitorDeatils.data.visitorName
        //     }
        //     //console.log("sendSmsData", sendSmsData);
        //     const updateSendSms = await axios.post('/SendSMS', sendSmsData);
        //     //console.log("updateSendSms", updateSendSms);

        //   }


        // } catch (error) {
        //   console.error('Error fetching appointment details:', error);
        //   // Handle error scenarios
        // }

      }

    }

  };
  const handleClose = () => {
    setSearchQuery(""); // Clear the search query
    setCurrentPage(1);
    setShowTable(false); // Show table on card click
    setselectedOption('') // Show table on card click
    setSelectedEntity("All");   // ✅ reset dropdown text to All
    setSelectedEntityId(0); const fetchCardCounts = async () => {
      try {
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

        const response = await axios.get(`${API_BASE_URL}/Dashboard/${0},${0},${0}`);
        const data = response.data;
        setCardCounts({
          expectedVisitors: data.expectedCount,
          checkedIn: data.checkedin,
          inPremises: data.inPremises,
          crossedDeadlines: data.crossed,
          upcomingDeadlines: data.udCount,
          checkedOut: data.checkedout,
        });
      } catch (error) {
        console.error('Error fetching card counts:', error);
      }
    };

    const fetchMonthCounts = async () => {
      try {
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

        const responseMonth = await axios.get(`${API_BASE_URL}/VisitorDetails/GetVisitorVIPDetails/${0},${0}`);
        const data = responseMonth.data;

        const labels = data.map(item => item.onDay);
        const checkinData = data.map(item => parseInt(item.checkin, 10));
        const checkoutData = data.map(item => parseInt(item.checkout || 0, 10)); // Handle empty checkout values

        setLineChartData({
          labels: labels,
          datasets: [
            {
              label: 'Checked-In',
              data: checkinData,
              borderColor: '#293495',
              backgroundColor: 'rgba(41, 52, 149, 0.2)',
              fill: true,
              tension: 0.4, // Smooth curves
            },
            {
              label: 'Checked-Out',
              data: checkoutData,
              borderColor: '#FFA500',
              backgroundColor: 'rgba(255, 165, 0, 0.2)',
              fill: true,
              tension: 0.4, // Smooth curves

            },
          ],
        });
      } catch (error) {
        console.error('Error fetching month counts:', error);
      }
    };



    const fetchChartData = async () => {
      try {
        const today = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;

        const responseChart = await axios.get(`${API_BASE_URL}/VisitorDetails/GetFVMSCheckInVisitor/${today},${0},${0}`);
        const chartData = responseChart.data;

        const labels = chartData.map(item => item.onTime);
        const data = chartData.map(item => parseInt(item.visitors, 10));

        setBarChartData({
          labels: labels,
          datasets: [
            {
              label: 'Counts',
              data: data,
              backgroundColor: '#293495',
            },
          ],
        });
      } catch (error) {
        console.error('Error fetching Chart counts:', error);
      }
    };

    fetchCardCounts();
    fetchChartData();
    fetchMonthCounts();// Show table on card click


  };
  const handleCloseFilter = () => {
    setShowTableFilter(false);
    setSelectedEntity("All");   // ✅ reset dropdown text to All
    setSelectedEntityId(0);


  };
  const [errorMessage, setErrorMessage] = useState('');

  const [showTable, setShowTable] = useState(false);
  const [showTableFilter, setShowTableFilter] = useState(false); // State to control table visibility
  const [tableData, setTableData] = useState([]);
  const [tableDataGate, setTableDataGate] = useState([]); // Use an array for table data
  // Use an array for table data
  const [cardData, setcardData] = useState([]);
  const [cardDataGate, setcardDataGate] = useState([]); // Use an array for table data
  // Use an array for table data
  const [showIcon, setIcon] = useState('');


  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 7;

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };
  const normalizeText = (text) => {
    return text
      ?.toString()
      .replace(/[\t\n\r\u00A0]+/g, ' ') // Replace tabs, newlines, carriage returns, and non-breaking spaces with a single space
      .replace(/\s+/g, ' ') // Collapse multiple spaces into a single space
      .trim()
      .toLowerCase();
  };

  const normalizedSearchQuery = normalizeText(searchQuery);
  const filteredRows = tableData.filter((visitor) => {
    return (
      visitor.appointmentId?.toString().includes(searchQuery) ||
      visitor.source?.toLowerCase().includes(searchQuery) ||
      visitor.visitorName?.toLowerCase().includes(normalizedSearchQuery) ||
      visitor.visitorTypeDesc?.toLowerCase().includes(searchQuery) ||
      visitor.idProof?.toLowerCase().includes(searchQuery) ||
      visitor.nationality?.toLowerCase().includes(searchQuery) ||
      visitor.visitorMobile?.toString().includes(searchQuery) ||
      visitor.host?.toLowerCase().includes(searchQuery) ||
      visitor.location?.toLowerCase().includes(searchQuery) ||
      visitor.purpose?.toLowerCase().includes(searchQuery) ||
      (visitor.checkInType && visitor.checkInType.toLowerCase().includes(searchQuery)) ||
      visitor.status?.toLowerCase().includes(searchQuery)
    );
  });
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);

  const currentRows = filteredRows.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const currentRowsGate = tableDataGate.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (event) => {
    setCurrentPage(Number(event.target.value));
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');
  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredRows.length / rowsPerPage);
  const sortData = (data, column, direction) => {
    const sortedData = [...data].sort((a, b) => {
      if (direction === 'asc') {
        return a[column] > b[column] ? 1 : -1;
      } else {
        return a[column] < b[column] ? 1 : -1;
      }
    });
    return sortedData;
  };

  const handleSort = (column) => {
    const direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortDirection(direction);
    const sortedData = sortData(filteredRows, column, direction);
    setTableData(sortedData);
  };
  const [isPanelOpenE, setIsPanelOpenE] = useState(false);

  // Function to toggle the export options panel
  const togglePanelE = () => {
    setIsPanelOpenE((prevState) => !prevState);
  };

  const handleExportOptionClick = (format) => {
    if (filteredRows.length === 0) {
      toast.warning('No data available to export.');
      return;
    }
    if (format === 'excel') {
      exportToExcel(); // Call the Excel export function
    } else if (format === 'pdf') {
      exportToPDF(); // Call the PDF export function
    }

    // Close the panel after making a selection
    setIsPanelOpenE(false);
  };
  const exportToExcel = () => {
    // Map filteredRows to include only the selected columns
    const APPID = cardData === 'expected Visitors' ? 'Appt ID' : 'VisitId(Appt Id)';
    const APPType = cardData === 'expected Visitors' ? 'Appt Type' : 'Visit Type';
    const CheckIn = cardData === 'expected Visitors' ? 'Meeting From' : 'Checked-In';
    const Pass = cardData === 'expected Visitors' ? 'Meeting To' : 'Pass Returned';
    const isPassColumnIncluded = cardData !== 'in Premises' && cardData !== 'crossed Deadlines' && cardData !== 'upcoming Deadlines';
    const isMeetingEndIncluded = cardData === 'in Premises';

    const filteredData = filteredRows.map((row) => ({

      [APPID]: row.appointmentId,
      [APPType]: row.source,
      visitorName: row.visitorName,
      visitorType: row.visitorTypeDesc,
      Mobile: row.visitorMobile,
      nationality: row.nationality,
      idProof: row?.idProof,
      host: row.host,
      location: row.location,
      Purpose: row.purpose,
      [CheckIn]: row.checkInDateTime,
      ...(isMeetingEndIncluded ? { "Meeting End": row.meetingTo } : {}),
      ...(isPassColumnIncluded ? { [Pass]: row.passReturnedDateTime } : {}), // Add "Pass" data conditionally
      recurring: row.recurring,
      status: row.status,
    }));

    // Create the worksheet with the filtered data
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Visitor Details');

    // Adjust column widths for better alignment (optional)
    worksheet['!cols'] = [
      { wpx: 100 }, // appointmentId
      { wpx: 150 }, // source
      { wpx: 150 }, // visitorName
      { wpx: 150 }, // visitorTypeDesc
      { wpx: 150 }, // visitorMobile
      { wpx: 150 }, // visitorMobile
      { wpx: 150 }, // host
      { wpx: 150 }, // id proof
      { wpx: 150 }, // location
      { wpx: 150 },
      { wpx: 150 }, // location
      { wpx: 150 },  // Purpose
      { wpx: 150 }, // recurring
      { wpx: 100 }, // status
    ];

    // Write the file to Excel
    XLSX.writeFile(workbook, `${cardData}.xlsx`);
  };

  const exportToPDF = () => {
    const doc = new jsPDF('landscape'); // Landscape orientation
    doc.text('Visitor Details', 14, 16);
    //console.log("cardData", cardData);

    const isPassColumnIncluded = cardData !== 'in Premises' && cardData !== 'crossed Deadlines' && cardData !== 'upcoming Deadlines';

    // Dynamic column headers based on `cardData`
    const APPID = cardData === 'expected Visitors' ? 'ApptID' : 'VisitId';
    const APPType = cardData === 'expected Visitors' ? 'Appt Type' : 'Visit Type';
    const CheckIn = cardData === 'expected Visitors' ? 'MeetingFrom' : 'Checked-In';
    const Pass = cardData === 'expected Visitors' ? 'MeetingTo' : 'PassReturned';
    const isMeetingEndIncluded = cardData === 'in Premises';


    const columnHeaders = [
      'Photo',
      APPID,
      APPType,
      'Visitor Name',
      'Visitor Type',
      'Mobile',
      'Nationality',
      'IdProof',
      'Host',
      'Location',
      'Purpose',
      CheckIn,
      ...(isMeetingEndIncluded ? ['Meeting End'] : []),
      ...(isPassColumnIncluded ? [Pass] : []),
      'Recurring',
      'Status',
    ];

    doc.autoTable({
      head: [columnHeaders],
      body: filteredRows.map((row) => [
        '', // Placeholder for photo
        row.appointmentId || row.visitId || '',
        row.source || '',
        row.visitorName || '',
        row.visitorTypeDesc || row.visitType || '',
        row.visitorMobile || '',
        row.nationality || '',
        row?.idProof || '',
        row.host || '',
        row.location || '',
        row.purpose || '',
        row.meetingFrom || row.checkInDateTime || '',
        ...(isMeetingEndIncluded ? [row.meetingTo || ''] : []),
        ...(isPassColumnIncluded ? [row.meetingTo || row.passReturnedDateTime || ''] : []),
        row.recurring,
        row.status || '',
      ]),
      startY: 30,
      theme: 'grid',
      styles: {
        fontSize: 8, // Small font size for better fit
        cellPadding: 2, // Minimize cell padding for compact layout
      },
      columnStyles: {
        0: { cellWidth: 20 }, // Photo column
      },
      tableWidth: 'auto', // Adjust table width to fit page
      didDrawCell: (data) => {
        if (data.section === 'body' && data.column.index === 0 && filteredRows[data.row.index]?.photo) {
          const img = `data:image/png;base64,${filteredRows[data.row.index].photo}`;

          // Get cell dimensions
          const cellWidth = data.cell.width;
          const cellHeight = data.cell.height;

          // Define the image size
          const imgSize = Math.min(cellWidth, cellHeight) - 2;

          // Center the image within the cell
          const xOffset = data.cell.x + (cellWidth - imgSize) / 2;
          const yOffset = data.cell.y + (cellHeight - imgSize) / 2;

          doc.addImage(img, 'PNG', xOffset, yOffset, imgSize, imgSize);
        }
      },
    });

    doc.save('visitor_details.pdf');
  };

  // Change page handler
  // const handlePageChange = (direction) => {
  //   setCurrentPage((prevPage) => {
  //     if (direction === 'next' && prevPage < totalPages - 1) {
  //       return prevPage + 1;
  //     } else if (direction === 'prev' && prevPage > 0) {
  //       return prevPage - 1;
  //     }
  //     return prevPage;
  //   });
  // };
  const formatCardTitle = (key) => {
    if (key === 'checkedIn') return 'Checked-In';
    if (key === 'checkedOut') return 'Checked-Out';
    if (key === 'inPremises') return 'In-Premises';

    return key
      .replace(/([A-Z])/g, ' $1') // Insert space before each capital letter
      .replace(/^./, (str) => str.toUpperCase()) // Capitalize the first letter
      .trim(); // Remove any extra whitespace
  };
  // const handleIconClick = (mobileNumber) => {
  //   //console.log

  // }
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [options, setOptions] = useState([]);

  // Function to toggle the dropdown panel
  const togglePanel = () => {
    setIsPanelOpen(!isPanelOpen);
  };


  // Fetch options from API
  useEffect(() => {
    const fetchOptions = async () => {
      // Replace with your API endpoint
      const venues = await fetchGateDetails();
      //console.log("Gate Details", venues);

      setOptions(venues); // Assuming the API returns an array of options
    };

    fetchOptions();
  }, []);
  const [selectedOption, setselectedOption] = useState();
  const [selectedOptionGate, setselectedOptionGate] = useState();
  const handleOptionClick = async (value, name) => {
    setIsPanelOpen(false);
    // setShowTableFilter(true);
    // setShowTable(false);

    //console.log("Selected option:", value);
    //console.log("Selected option:", name);
    setselectedOption(name);
    setcardDataGate(name)
    const updatedValue = name === "All" ? 0 : value; // Check if name is "ALL", and set value to 0 if true
    setselectedOptionGate(updatedValue);
    const fetchCardCounts = async () => {
      try {
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;
        const entityId = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationId = selectedLocationId !== undefined ? selectedLocationId : 0;

        const response = await axios.get(`${API_BASE_URL}/Dashboard/${updatedValue},${entityId},${locationId}`);
        const data = response.data;
        setCardCounts({
          expectedVisitors: data.expectedCount,
          checkedIn: data.checkedin,
          inPremises: data.inPremises,
          crossedDeadlines: data.crossed,
          upcomingDeadlines: data.udCount,
          checkedOut: data.checkedout,
        });
      } catch (error) {
        console.error('Error fetching card counts:', error);
      }
    };

    const fetchMonthCounts = async () => {
      try {
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;
        const entityId = selectedEntityId !== undefined ? selectedEntityId : 0;

        const responseMonth = await axios.get(`${API_BASE_URL}/VisitorDetails/GetVisitorVIPDetails/${updatedValue},${entityId}`);
        const data = responseMonth.data;

        const labels = data.map(item => item.onDay);
        const checkinData = data.map(item => parseInt(item.checkin, 10));
        const checkoutData = data.map(item => parseInt(item.checkout || 0, 10)); // Handle empty checkout values

        setLineChartData({
          labels: labels,
          datasets: [
            {
              label: 'Checked-In',
              data: checkinData,
              borderColor: '#293495',
              backgroundColor: 'rgba(41, 52, 149, 0.2)',
              fill: true,
              tension: 0.4, // Smooth curves
            },
            {
              label: 'Checked-Out',
              data: checkoutData,
              borderColor: '#FFA500',
              backgroundColor: 'rgba(255, 165, 0, 0.2)',
              fill: true,
              tension: 0.4, // Smooth curves

            },
          ],
        });
      } catch (error) {
        console.error('Error fetching month counts:', error);
      }
    };



    const fetchChartData = async () => {
      try {
        const today = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;
        const entityId = selectedEntityId !== undefined ? selectedEntityId : 0;

        const responseChart = await axios.get(`${API_BASE_URL}/VisitorDetails/GetFVMSCheckInVisitor/${today},${updatedValue},${entityId}`);
        const chartData = responseChart.data;

        const labels = chartData.map(item => item.onTime);
        const data = chartData.map(item => parseInt(item.visitors, 10));

        setBarChartData({
          labels: labels,
          datasets: [
            {
              label: 'Counts',
              data: data,
              backgroundColor: '#293495',
            },
          ],
        });
      } catch (error) {
        console.error('Error fetching Chart counts:', error);
      }
    };

    fetchCardCounts();
    fetchChartData();
    fetchMonthCounts();

    if (cardData == 'expected Visitors') {
      setLoading(true);
      setIconShow(true); // or whatever logic you want for other roles
      setIcon(faMobileAlt)
      //console.log("API should call");
      try {
        // const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${1}`);
        const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;
        const entityId = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationId = selectedLocationId !== undefined ? selectedLocationId : 0;

        const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${1},${updatedValue},${entityId},${locationId}`);

        //console.log("response", response);
        setTableData(response.data.details)
      } catch (error) {
        console.error('Error submitting form:', error);
        setErrorMessage('No visitors to display'); // Set error message if API call fails
        setTableData([]); // Clear table data

      }
      finally {
        setLoading(false); // Hide loader
      }

    } else if (cardData == 'checked In') {
      setLoading(true);
      if (roleName !== "Gate Reception") {
        setIconShow(false); // or whatever logic you want for other roles
      }
      else {
        setIconShow(true); // or whatever logic you want for other roles

      }
      setIcon(faMobileAlt)

      try {
        const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;
        const entityId = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationId = selectedLocationId !== undefined ? selectedLocationId : 0;
        const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${2},${updatedValue},${entityId},${locationId}`);
        //console.log("response", response);
        setTableData(response.data.details)
      } catch (error) {
        console.error('Error submitting form:', error);
        console.error('Error submitting form:', error);
        setErrorMessage('No visitors to display'); // Set error message if API call fails
        setTableData([]); // Clear table data

      }
      finally {
        setLoading(false); // Hide loader
      }

    } else if (cardData == 'crossed Deadlines') {
      setLoading(true);
      if (roleName !== "Gate Reception") {
        setIconShow(false); // or whatever logic you want for other roles
      }
      else {
        setIconShow(true); // or whatever logic you want for other roles

      }
      setIcon(faMobileAlt)

      try {
        const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;
        const entityId = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationId = selectedLocationId !== undefined ? selectedLocationId : 0;

        const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${4},${updatedValue},${entityId},${locationId}`);
        //console.log("response", response);
        setTableData(response.data.details)
      } catch (error) {
        console.error('Error submitting form:', error);
        setErrorMessage('No visitors to display'); // Set error message if API call fails
        setTableData([]); // Clear table data

      }
      finally {
        setLoading(false); // Hide loader
      }

    } else if (cardData == 'upcoming Deadlines') {
      setLoading(true);
      if (roleName !== "Gate Reception") {
        setIconShow(false); // or whatever logic you want for other roles
      }
      else {
        setIconShow(true); // or whatever logic you want for other roles

      }
      setIcon(faMobileAlt)

      try {
        const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;
        const entityId = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationId = selectedLocationId !== undefined ? selectedLocationId : 0;

        const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${5},${updatedValue},${entityId},${locationId}`);
        //console.log("response", response);
        setTableData(response.data.details)

      } catch (error) {
        console.error('Error submitting form:', error);
        setErrorMessage('No visitors to display'); // Set error message if API call fails
        setTableData([]); // Clear table data

      }
      finally {
        setLoading(false); // Hide loader
      }

    } else if (cardData == 'checked Out') {
      setLoading(true);
      setIconShow(false);
      try {
        const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;
        const entityId = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationId = selectedLocationId !== undefined ? selectedLocationId : 0;

        const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${6},${updatedValue},${entityId},${locationId}`);
        //console.log("response", response);
        setTableData(response.data.details)
      } catch (error) {
        console.error('Error submitting form:', error);
        setErrorMessage('No visitors to display'); // Set error message if API call fails
        setTableData([]); // Clear table data

      }
      finally {
        setLoading(false); // Hide loader
      }

    } else if (cardData == 'in Premises') {
      setLoading(true);
      if (roleName !== "Gate Reception") {
        setIconShow(false); // or whatever logic you want for other roles
      }
      setIcon(faMobileAlt)

      try {
        const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;
        const entityId = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationId = selectedLocationId !== undefined ? selectedLocationId : 0;

        const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${3},${updatedValue},${entityId},${locationId}`);
        //console.log("response", response);
        setTableData(response.data.details)

      } catch (error) {
        console.error('Error submitting form:', error);
        setErrorMessage('No visitors to display'); // Set error message if API call fails
        setTableData([]); // Clear table data

      }
      finally {
        setLoading(false); // Hide loader
      }

    }


    // try {
    //   const response = await axios.get(`/Report/GetVisitorsListandCountByGate?gate=${value}`);
    //   //console.log("response", response);
    //   setTableDataGate(response.data)

    // } catch (error) {
    //   console.error('Error submitting form:', error);

    // }  // Show table on card click
    // Close the panel after selecting an option
    // Implement your option click logic here
  };
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsPanelOpen(false);
    }
    if (entityDropdownRef.current && !entityDropdownRef.current.contains(event.target)) {
      setIsEntityPanelOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedVisitor, setSelectedVisitor] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedVisitorDetails, setSelectedVisitorDetails] = useState(null);
  const handleViewDetails = (visitor) => {
    setSelectedVisitorDetails(visitor);
    setShowDetailsModal(true);
  };

  const formatDate = (dateString) => {
    return new Intl.DateTimeFormat('en-CA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).format(new Date(dateString)).replace(',', ' :');
  };

  // 🔹 Reusable inline component for consistency
  const Detail = ({ label, value }) => (
    <div>
      <span style={{ fontWeight: 'bold', color: '#555' }}>{label}:</span>{' '}
      <span style={{ color: '#333' }}>{value}</span>
    </div>
  );
  const [entityOptions, setEntityOptions] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState("All");
  const [selectedEntityId, setSelectedEntityId] = useState(0);
  const [isEntityPanelOpen, setIsEntityPanelOpen] = useState(false);
  const [locationOptions, setLocationOptions] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("All");
  const [selectedLocationId, setSelectedLocationId] = useState(0);

  const entityDropdownRef = useRef(null);

  useEffect(() => {
    const fetchEntities = async () => {
      try {
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;
        const response = await axios.get(`${API_BASE_URL}/Entity/GetEntity`);
        setEntityOptions(response.data || []);
      } catch (error) {
        console.error("Error fetching entities:", error);
      }
    };

    fetchEntities();
  }, []);

  useEffect(() => {
  if (selectedRoleId && employeeId && roleName === "Gate Reception") {
    const fetchLocationsByRoleAndEmpId = async () => {
      try {
        const response = await axios.post(`/Location/GetLocationByRoleIdandEmpId/${selectedRoleId}/${employeeId}`);
        if (response?.data?.code === 0 && response?.status === 200) {
          const locations = response?.data?.data || [];
          setLocationOptions(locations);
          const firstLocationId = locations[0]?.id || 0;
          setSelectedLocationId(firstLocationId);
          localStorage.setItem('selectedLocationId', firstLocationId);
          console.log("Fetched locations based on role and employee ID:", firstLocationId);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };
    fetchLocationsByRoleAndEmpId();
  } else {
    const fetchLocations = async () => {
      try {
        const response = await axios.get('/Location');
        setLocationOptions(response.data || []);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };
    fetchLocations();
  }
}, [selectedRoleId, employeeId, roleName]);

  const handleEntityClick = async (id, name) => {
    setIsEntityPanelOpen(false);
    setSelectedEntity(name);
    const updatedEntityId = name === "All" ? 0 : id;
    setSelectedEntityId(updatedEntityId);

    // If gate not selected, default to 0
    const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;


    const fetchCardCounts = async () => {
      try {
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;
        const entityId = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationId = selectedLocationId !== undefined ? selectedLocationId : 0;

        const response = await axios.get(`${API_BASE_URL}/Dashboard/${gateId},${updatedEntityId},${locationId}`);
        const data = response.data;
        setCardCounts({
          expectedVisitors: data.expectedCount,
          checkedIn: data.checkedin,
          inPremises: data.inPremises,
          crossedDeadlines: data.crossed,
          upcomingDeadlines: data.udCount,
          checkedOut: data.checkedout,
        });
      } catch (error) {
        console.error('Error fetching card counts:', error);
      }
    };

    const fetchMonthCounts = async () => {
      try {
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;
        const entityId = selectedEntityId !== undefined ? selectedEntityId : 0;

        const responseMonth = await axios.get(`${API_BASE_URL}/VisitorDetails/GetVisitorVIPDetails/${gateId},${updatedEntityId}`);
        const data = responseMonth.data;

        const labels = data.map(item => item.onDay);
        const checkinData = data.map(item => parseInt(item.checkin, 10));
        const checkoutData = data.map(item => parseInt(item.checkout || 0, 10)); // Handle empty checkout values

        setLineChartData({
          labels: labels,
          datasets: [
            {
              label: 'Checked-In',
              data: checkinData,
              borderColor: '#293495',
              backgroundColor: 'rgba(41, 52, 149, 0.2)',
              fill: true,
              tension: 0.4, // Smooth curves
            },
            {
              label: 'Checked-Out',
              data: checkoutData,
              borderColor: '#FFA500',
              backgroundColor: 'rgba(255, 165, 0, 0.2)',
              fill: true,
              tension: 0.4, // Smooth curves

            },
          ],
        });
      } catch (error) {
        console.error('Error fetching month counts:', error);
      }
    };



    const fetchChartData = async () => {
      try {
        const today = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format
        const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;
        const entityId = selectedEntityId !== undefined ? selectedEntityId : 0;

        const responseChart = await axios.get(`${API_BASE_URL}/VisitorDetails/GetFVMSCheckInVisitor/${today},${gateId},${updatedEntityId}`);
        const chartData = responseChart.data;

        const labels = chartData.map(item => item.onTime);
        const data = chartData.map(item => parseInt(item.visitors, 10));

        setBarChartData({
          labels: labels,
          datasets: [
            {
              label: 'Counts',
              data: data,
              backgroundColor: '#293495',
            },
          ],
        });
      } catch (error) {
        console.error('Error fetching Chart counts:', error);
      }
    };

    fetchCardCounts();
    fetchChartData();
    fetchMonthCounts();

    if (cardData == 'expected Visitors') {
      setLoading(true);
      setIconShow(true); // or whatever logic you want for other roles
      setIcon(faMobileAlt)
      //console.log("API should call");
      try {
        // const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${1}`);
        const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;
        const entityId = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationId = selectedLocationId !== undefined ? selectedLocationId : 0;

        const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${1},${gateId},${updatedEntityId},${locationId}`);

        //console.log("response", response);
        setTableData(response.data.details)
      } catch (error) {
        console.error('Error submitting form:', error);
        setErrorMessage('No visitors to display'); // Set error message if API call fails
        setTableData([]); // Clear table data

      }
      finally {
        setLoading(false); // Hide loader
      }

    } else if (cardData == 'checked In') {
      setLoading(true);
      if (roleName !== "Gate Reception") {
        setIconShow(false); // or whatever logic you want for other roles
      }
      else {
        setIconShow(true); // or whatever logic you want for other roles

      }
      setIcon(faMobileAlt)

      try {
        const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;
        const entityId = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationId = selectedLocationId !== undefined ? selectedLocationId : 0;
        const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${2},${gateId},${updatedEntityId},${locationId}`);
        //console.log("response", response);
        setTableData(response.data.details)
      } catch (error) {
        console.error('Error submitting form:', error);
        console.error('Error submitting form:', error);
        setErrorMessage('No visitors to display'); // Set error message if API call fails
        setTableData([]); // Clear table data

      }
      finally {
        setLoading(false); // Hide loader
      }

    } else if (cardData == 'crossed Deadlines') {
      setLoading(true);
      if (roleName !== "Gate Reception") {
        setIconShow(false); // or whatever logic you want for other roles
      }
      else {
        setIconShow(true); // or whatever logic you want for other roles

      }
      setIcon(faMobileAlt)

      try {
        const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;
        const entityId = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationId = selectedLocationId !== undefined ? selectedLocationId : 0;

        const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${4},${gateId},${updatedEntityId},${locationId}`);
        //console.log("response", response);
        setTableData(response.data.details)
      } catch (error) {
        console.error('Error submitting form:', error);
        setErrorMessage('No visitors to display'); // Set error message if API call fails
        setTableData([]); // Clear table data

      }
      finally {
        setLoading(false); // Hide loader
      }

    } else if (cardData == 'upcoming Deadlines') {
      setLoading(true);
      if (roleName !== "Gate Reception") {
        setIconShow(false); // or whatever logic you want for other roles
      }
      else {
        setIconShow(true); // or whatever logic you want for other roles

      }
      setIcon(faMobileAlt)

      try {
        const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;
        const entityId = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationId = selectedLocationId !== undefined ? selectedLocationId : 0;

        const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${5},${gateId},${updatedEntityId},${locationId}`);
        //console.log("response", response);
        setTableData(response.data.details)

      } catch (error) {
        console.error('Error submitting form:', error);
        setErrorMessage('No visitors to display'); // Set error message if API call fails
        setTableData([]); // Clear table data

      }
      finally {
        setLoading(false); // Hide loader
      }

    } else if (cardData == 'checked Out') {
      setLoading(true);
      setIconShow(false);
      try {
        const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;
        const entityId = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationId = selectedLocationId !== undefined ? selectedLocationId : 0;

        const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${6},${gateId},${updatedEntityId},${locationId}`);
        //console.log("response", response);
        setTableData(response.data.details)
      } catch (error) {
        console.error('Error submitting form:', error);
        setErrorMessage('No visitors to display'); // Set error message if API call fails
        setTableData([]); // Clear table data

      }
      finally {
        setLoading(false); // Hide loader
      }

    } else if (cardData == 'in Premises') {
      setLoading(true);
      if (roleName !== "Gate Reception") {
        setIconShow(false); // or whatever logic you want for other roles
      }
      setIcon(faMobileAlt)

      try {
        const gateId = selectedOptionGate !== undefined ? selectedOptionGate : 0;
        const entityId = selectedEntityId !== undefined ? selectedEntityId : 0;
        const locationId = selectedLocationId !== undefined ? selectedLocationId : 0;
        const response = await axios.get(`/Dashboard/GetVisitorStatsByDashboard/${3},${gateId},${updatedEntityId},${locationId}`);
        //console.log("response", response);
        setTableData(response.data.details)

      } catch (error) {
        console.error('Error submitting form:', error);
        setErrorMessage('No visitors to display'); // Set error message if API call fails
        setTableData([]); // Clear table data

      }
      finally {
        setLoading(false); // Hide loader
      }

    }

  };

  const handleLocationClick = async (id, name) => {
  setSelectedLocation(name);
  const updatedLocationId = name === "All" ? 0 : id;
  setSelectedLocationId(updatedLocationId);

  // Reset gate and entity selections
  setselectedOption('');
  setselectedOptionGate(0);
  setSelectedEntity("All");
  setSelectedEntityId(0);

  // Fetch filtered gates and entities based on location
  if (updatedLocationId !== 0) {
  try {
    const gateRes = await axios.get(`/Location/GetBuildingsByLocation?locationID=${updatedLocationId}`);
    setFilteredGateOptions(gateRes.data || []);
  } catch (error) {
    console.error("Error fetching gates by location:", error);
    setFilteredGateOptions([]);
  }

  try {
    const entityRes = await axios.post(`/Entity/GetEntityByLocationId/${updatedLocationId}`);
    setFilteredEntityOptions(entityRes.data?.data || []);
  } catch (error) {
    console.error("Error fetching entities by location:", error);
    setFilteredEntityOptions([]);
  }
} else {
  setFilteredGateOptions([]);
  setFilteredEntityOptions([]);
}

  const gateId = 0;
  const entityId = 0;

  const fetchCardCounts = async () => {
    try {
      const API_BASE_URL = window.APP_CONFIG?.API_BASE_URL;
      const response = await axios.get(`${API_BASE_URL}/Dashboard/${gateId},${entityId},${updatedLocationId}`);
      const data = response.data;
      setCardCounts({
        expectedVisitors: data.expectedCount,
        checkedIn: data.checkedin,
        inPremises: data.inPremises,
        crossedDeadlines: data.crossed,
        upcomingDeadlines: data.udCount,
        checkedOut: data.checkedout,
      });
    } catch (error) {
      console.error('Error fetching card counts:', error);
    }
  };

  if (cardData) {
    const statMap = {
      'expected Visitors': 1, 'checked In': 2, 'in Premises': 3,
      'crossed Deadlines': 4, 'upcoming Deadlines': 5, 'checked Out': 6,
    };
    const statId = statMap[cardData];
    if (statId) {
      try {
        setLoading(true);
        const response = await axios.get(
          `/Dashboard/GetVisitorStatsByDashboard/${statId},${gateId},${entityId},${updatedLocationId}`
        );
        setTableData(response.data.details);
      } catch (error) {
        setTableData([]);
        toast.error("No visitors to display");
      } finally {
        setLoading(false);
      }
    }
  }

  fetchCardCounts();
};

  const [mobileNumber, setMobileNumber] = useState('');

  const [nationalityList, setNationalityList] = useState('');

  const [defaultNationalityCode, setDefaultNationalityCode] = useState('');

  const [selected, setSelected] = useState("number");
  const [idProof, setIdProof] = useState("")
  const [selectedIdProofTypeId, setSelectedIdProofTypeId] = useState("")


  const handleIsdChange = (e) => {
    setMobileNumber('')
    const selectedNationality = nationalityList.find(
      (nation) => nation.nationalityCode === e.target.value
    );

    if (selectedNationality) {
      //console.log("Selected Nationality Code:", selectedNationality.nationalityCode);
      setDefaultNationalityCode(selectedNationality.nationalityCode);
    }
  };
  const handleInputChange = (e) => {
    // Only allow numeric input
    if (/^\d*$/.test(e.target.value)) {
      setMobileNumber(e.target.value);
    }

    //setMobileNumber(e.target.value);
  };

  const [baggageTag, setBaggageTag] = useState('')
  const [showBaggageTag, setShowBaggageTag] = useState(false);
  const [detailsVisitor, setDetailsVisitor] = useState({});

  useEffect(() => {
    // Expose global function for HTML buttons
    window.baggageTagClose = () => {
      setShowBaggageTag(false); // hide popup if needed
      handleReprintPassBoth(detailsVisitor)
    };

    window.baggageTagPrint = () => {
      if (!baggageTag) {
        console.warn('No baggage tag data to print');
        return;
      }

      // Create a hidden iframe for printing
      const iframe = document.createElement('iframe');
      iframe.style.position = 'absolute';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = 'none';
      document.body.appendChild(iframe);

      // Set the onload handler BEFORE writing document
      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow.print();
          document.body.removeChild(iframe);
        }, 500);
      };

      // Write baggageTag HTML into the iframe
      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(`
        <html>
          <head>
            <title>Baggage Tag</title>
            <style>
                @page { size: auto; margin: 0; }
                @media print {
                  body { margin: 0 !important; padding: 0 !important; }
                  * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
                }
            </style>
          </head>
          <body>
            ${baggageTag}
          </body>
        </html>
        `);

      doc.close();
    };
  }, [detailsVisitor, baggageTag]);

  const handleReprintPass = async (visitor) => {
    try {
      // console.log(" Visitor Data:", visitor);

      // 1. Extract and clean check-in ID
      let rawCheckInId = visitor.appointmentId; // sometimes returns like "91 (51)"
      if (!rawCheckInId) {
        console.error(" No checkInId found for visitor");
        toast.error("Check-in ID not found");
        return;
      }

      const cleanedCheckInId = rawCheckInId.toString().split(' ')[0].split('(')[0];
      const visitType = visitor.source; // or visitor.visitType depending on your data

      // console.log(" Cleaned CheckInId:", cleanedCheckInId);
      // console.log(" VisitType:", visitType);

      // 2. API call
      const response = await axios.get(
        `/VisitorDetails/GetRePrintPassByCheckInId/${cleanedCheckInId},${visitType}`
      );

      // console.log("Reprint Pass API Response:", response.data);

      //  3. Handle API error
      if (response.data.statusCode === "-1") {
        toast.error(response.data.statusMessage || "Failed to fetch reprint pass.");
        return;
      }

      // 4. Handle reprint pass details
      let Details = response.data.reprintPassDetails;
      const detailsArray = Array.isArray(Details) ? Details : [Details];

      if (!detailsArray || detailsArray.length === 0) {
        toast.warning("No visitor pass available.");
        return;
      }

      for (const detail of detailsArray) {
        if (!detail.badgeFront && !detail.badgeBack) {
          toast.warning("No visitor pass available.");
          return;
        }


        //  If baggageTag exists → show it first, store iframe for later
        if (detail.baggageTag) {
          //console.log(detail.baggageTag);
          setBaggageTag(detail.baggageTag);
          setDetailsVisitor(detail)
          setShowBaggageTag(true);
        } else {
          handleReprintPassBoth(detail)
        }
      }
    } catch (error) {
      console.error(" Error in handleReprintPass:", error);
      toast.error("Something went wrong while reprinting the pass.");
    }
  };


  const handleReprintPassBoth = async (detail) => {
    try {
      if (!detail.badgeFront && !detail.badgeBack) {
        toast.warning("No visitor pass available.");
        return;
      }

      // ✅ 5. Create hidden iframe for printing
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(`
        <html>
          <head>
            <title>Visitor Pass</title>
            <style>
              @page { margin: 0; }
              body { 
                margin: 0; 
                display: flex; 
                justify-content: space-around;
                align-items: flex-start;
                padding: 5px;
              }
              .badge {
                margin: 10px;
                width: 8cm;      
                height: 49cm;    
                box-sizing: border-box;
              }
              @media print {
                .no-print { display: none; }
              }
            </style>
          </head>
          <body>
            <div class="badge">
              ${detail.badgeFront || ""}
            </div>
            <div class="badge">
              ${detail.badgeBack || ""}
            </div>
          </body>
        </html>
      `);
      doc.close();

      //  6. Trigger print after iframe loads
      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow.print();
          document.body.removeChild(iframe);
        }, 500);
      };

    } catch (error) {
      console.error(" Error in handleReprintPass:", error);
      toast.error("Something went wrong while reprinting the pass.");
    }
  };





  return (
    <DashboardWrapper>
      {loading && <Loader />}
      <Container>
        <PageHeading>Dashboard</PageHeading>
        <DropdownGroup>
          <DropdownContainerTwo>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <label style={{ fontSize: '12px', fontWeight: '600', color: '#2B3497' }}>Location</label>
              <select
                value={selectedLocationId || 0}
                onChange={(e) => {
                  const selected = locationOptions.find(o => o.id === Number(e.target.value));
                  handleLocationClick(Number(e.target.value), selected ? selected.locationName : 'All');
                  console.log("Selected Location ID:", Number(e.target.value));
                }}
                style={{
                  padding: '6px 10px', borderRadius: '6px', border: '1px solid #3d46b4',
                  color: '#293495', fontSize: '14px', cursor: 'pointer', outline: 'none', minWidth: '140px'
                }}
              >
                {roleName === "Gate Reception" ? (
                  <></>
                ) : (
                  <option value={0}>All</option>
                )}
                {locationOptions.map((option) => (
                  <option key={option.id} value={option.id}>{option.locationName}</option>
                ))}
              </select>
            </div>
          </DropdownContainerTwo>
          <DropdownContainerTwo ref={dropdownRef}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <label style={{ fontSize: '12px', fontWeight: '600', color: '#2B3497' }}>Gate</label>
              <select
                value={selectedOptionGate || 0}
                onChange={(e) => {
                  const activeList = filteredGateOptions.length > 0 ? filteredGateOptions : [];
                  const selected = activeList.find(o => o.id === Number(e.target.value));
                  handleOptionClick(Number(e.target.value), selected ? selected.name : 'All');
                }}
                style={{
                  padding: '6px 10px', borderRadius: '6px', border: '1px solid #3d46b4',
                  color: '#293495', fontSize: '14px', cursor: 'pointer', outline: 'none', minWidth: '140px'
                }}
              >
                <option value={0}>All</option>
                {(filteredGateOptions.length > 0 ? filteredGateOptions : []).map((option) => (
                  <option key={option.id} value={option.id}>{option.name}</option>
                ))}
              </select>
            </div>
          </DropdownContainerTwo>
          <DropdownContainerTwo ref={entityDropdownRef}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <label style={{ fontSize: '12px', fontWeight: '600', color: '#2B3497' }}>Entity</label>
              <select
                value={selectedEntityId || 0}
                onChange={(e) => {
                  const activeList = filteredEntityOptions.length > 0 ? filteredEntityOptions : [];
                  const selected = activeList.find(o => o.id === Number(e.target.value));
                  handleEntityClick(Number(e.target.value), selected ? selected.entityName : 'All');
                }}
                style={{
                  padding: '6px 10px', borderRadius: '6px', border: '1px solid #3d46b4',
                  color: '#293495', fontSize: '14px', cursor: 'pointer', outline: 'none', minWidth: '140px'
                }}
              >
                <option value={0}>All</option>
                {(filteredEntityOptions.length > 0 ? filteredEntityOptions : []).map((option) => (
                  <option key={option.id} value={option.id}>{option.entityName}</option>
                ))}
              </select>
            </div>
          </DropdownContainerTwo>
        </DropdownGroup>
      </Container>
      <CardRow>
        {hasDashboardCheckInOut ?
          <Card
            key="walkin"
            bgColor="#0097A7" // light cyan color (you can change this)
            onClick={() => handleCardClick("Walk-in Check-in")}
          >
            <CardTitle>Walk-in Check-in</CardTitle>
            <CardCount>
              <FaWalking size={28} />
            </CardCount>
          </Card>
          : ""}

        {Object.keys(cardCounts).map((key, index) => (
          <Card
            key={key}
            bgColor={cardBackgroundColors[index]}
            onClick={() => handleCardClick(key.replace(/([A-Z])/g, ' $1').trim())} // Log card name on click
          >
            <CardTitle>{formatCardTitle(key)}</CardTitle> {/* Using a utility function to format the title */}
            <CardCount>{cardCounts[key]}</CardCount>
          </Card>
        ))}
        {hasDashboardCheckInOut ?
          <Card
            key="qrcheckin"
            bgColor="#0097A7" // light orange color (you can change this too)
            onClick={() => handleCardClick("QR Checkin/Checkout")}
          >
            <CardTitle>QR Checkin/Checkout</CardTitle>
            <CardCount >
              <FaQrcode />
            </CardCount>
          </Card>
          : ""}

      </CardRow>

      {!showTable && !showTableFilter && (
        <ChartRow>
          <ChartBox>
            <ChartHeader>Checked-In Visitors For Today</ChartHeader>
            <Bar data={barChartData} options={{
              scales: {
                x: {
                  title: {
                    display: true,
                    text: 'Time',  // Label for X-axis
                  },
                },
                y: {
                  title: {
                    display: true,
                    text: 'Counts',  // Label for Y-axis
                  },
                  ticks: {
                    precision: 0, // Ensures no decimal points on the Y-axis
                    beginAtZero: true, // Optional, ensures Y-axis starts from 0
                  },
                },
              },
            }} />
          </ChartBox>
          <ChartBox>
            <ChartHeader>Checked-In Checked-Out Visitors For The Month</ChartHeader>
            <Line data={lineChartData} options={{
              scales: {
                x: {
                  title: {
                    display: true,
                    text: 'Day',  // Label for X-axis
                  },

                },
                y: {
                  title: {
                    display: true,
                    text: 'Counts',  // Label for Y-axis
                  },
                },
              },
            }} />
          </ChartBox>
        </ChartRow>
      )}

      {showTable && (
        <PageHeadingWrapper>
          <PageHeading>
            {cardData === "checked In"
              ? "Checked-In"
              : cardData === "checked Out"
                ? "Checked-Out"
                : cardData === "in Premises"
                  ? "In-Premises"
                  : cardData.charAt(0).toUpperCase() + cardData.slice(1)}
          </PageHeading>

          <div style={{ display: 'flex', alignItems: 'center', position: 'absolute', right: '8%' }}>
            <SearchBox>
              <SearchIcon size={20} />
              <SearchInput
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </SearchBox>
            {/* <div
              style={{ cursor: "pointer", marginLeft: "12px", display: "flex", alignItems: "center" }}
              data-tooltip-id="checkin"
              data-tooltip-content="Walk-In Check-In "
              aria-label="Walkin Checkin"
            >
              <FaWalking size={25} color="#2B3397" />
            </div> */}

            {/* IMPORTANT: render Tooltip with the same id */}
            <Tooltip id="checkin" place="bottom" delayShow={80} />

            <DropdownContainerTwoo>
              <ExportIcono onClick={togglePanelE} title="Export">
                <FiDownload size={25} />
              </ExportIcono>
              {/* Show the panel with options if isPanelOpen is true */}
              {isPanelOpenE && (
                <OptionsPanelo>
                  <OptionItemo onClick={() => handleExportOptionClick('excel')}>Excel</OptionItemo>
                  <OptionItemo onClick={() => handleExportOptionClick('pdf')}>PDF</OptionItemo>
                </OptionsPanelo>
              )}
            </DropdownContainerTwoo>
          </div>


          <Button onClick={handleClose}>
            <AiOutlineClose />
          </Button>
        </PageHeadingWrapper>

      )}
      {showTableFilter && (
        <PageHeadingWrapper>
          <PageHeading>
            {cardDataGate}- Visitors List
          </PageHeading>

          <Button onClick={handleCloseFilter}>
            <AiOutlineClose />
          </Button>
        </PageHeadingWrapper>

      )}

      {qrPopupScreen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
        }}>
          <div style={{
            background: '#fff',
            borderRadius: '16px',
            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)',
            width: '448px',
            maxWidth: '95%',
            padding: '32px',
            position: 'relative',
            animation: 'fadeIn 0.3s ease-in-out',
            fontFamily: 'Segoe UI, sans-serif',
          }}>

            {/* Close Button */}
            <button
              onClick={() => setQrPopupScreen(false)}
              style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                background: 'transparent',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: '#999',
              }}
              aria-label="Close"
            >
              &times;
            </button>

            {/* Header */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>

              {qrPopupData?.visitorPhoto || qrPopupData?.photo ? (
                <img
                  src={`data:image/png;base64,${qrPopupData?.visitorPhoto || qrPopupData?.photo}`}
                  alt="Visitor"
                  style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    border: '3px solid #293495',
                    flexShrink: 0,
                  }}
                />
              ) : (
                <div
                  style={{
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                    backgroundColor: '#e0e0e0',
                    border: '3px solid #293495',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <ProfileIcon>
                    <User size={40} color="#293495" />
                  </ProfileIcon>
                </div>
              )}
              <div style={{ flex: 1 }}>
                <h2 style={{ margin: '0 0 4px', fontSize: '20px', color: '#293495' }}>
                  {qrPopupData?.visitorName}
                </h2>
                <div style={{ fontSize: '14px', color: '#555' }}>
                  <p style={{ margin: '2px 0' }}>
                    <strong>Appointment Type:</strong> {qrPopupData?.appointmentType || qrPopupData?.source}
                  </p>
                  <p style={{ margin: '2px 0' }}><strong>Mobile:</strong> {qrPopupData?.visitorMobile}</p>
                </div>
              </div>
            </div>


            <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '20px' }}>
              <button
                onClick={() =>
                  CheckedOut(qrPopupData)
                }
                style={{
                  backgroundColor: '#293495',
                  color: '#fff',
                  padding: '8px 20px',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                }}
              >
                Check-Out
              </button>
              <button
                onClick={() => {
                  setQrPopupScreen(false);
                  setQrPopupData({});
                }}
                style={{
                  backgroundColor: 'red',
                  color: '#fff',
                  padding: '8px 20px',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
            </div>

          </div>
        </div>
      )
      }

      {
        showTable && (

          <TableContainer>
            <StyledTable>
              <thead>
                <tr>
                  <TableHeader></TableHeader>
                  <TableHeader >Photo</TableHeader>
                  <TableHeader onClick={() => handleSort('appointmentId')}>{cardData === 'expected Visitors' ? 'App Id' : 'Visit Id(App Id)'}{sortColumn === 'appointmentId' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('source')}>{cardData === 'expected Visitors' ? 'Appt Type' : 'Visit Type'}{sortColumn === 'source' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('visitorName')}>Visitor Name{sortColumn === 'visitorName' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('visitorTypeDesc')}>{cardData === 'expected Visitors' ? 'Visitor Type' : 'Visitor Type'}{sortColumn === 'visitorTypeDesc' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('visitorMobile')}>Mobile{sortColumn === 'visitorMobile' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('nationality')}>Nationality{sortColumn === 'nationality' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('idProof')}>Id Proof{sortColumn === 'idProof' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('host')}>Host{sortColumn === 'host' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('location')}>Location{sortColumn === 'location' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  {/* <TableHeader onClick={() => handleSort('purpose')}>Purpose{sortColumn === 'purpose' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader> */}
                  {/* {cardData !== "expected Visitors" && <TableHeader onClick={() => handleSort('checkInType')}>Check-In Type{sortColumn === 'checkInType' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>} */}
                  <TableHeader onClick={() => handleSort('checkInDateTime')}>{cardData === 'expected Visitors' ? 'Meeting From' : 'Checked-In At'}{sortColumn === 'checkInDateTime' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  {cardData === 'in Premises' && (
                    <TableHeader onClick={() => handleSort('meetingTo')}>
                      Meeting End{sortColumn === 'meetingTo' && (sortDirection === 'asc' ? '↑' : '↓')}
                    </TableHeader>
                  )}
                  {cardData !== "in Premises" && cardData !== "crossed Deadlines" && cardData !== "upcoming Deadlines" && <TableHeader onClick={() => handleSort('passReturnedDateTime')}> {cardData === 'expected Visitors' ? 'Meeting To' : 'Pass Returned At'}{sortColumn === 'passReturnedDateTime' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>}
                  <TableHeader onClick={() => handleSort('recurring')}>Recurring{sortColumn === 'recurring' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('status')}>Status{sortColumn === 'status' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  {iconShow && <TableHeader>{cardData === 'expected Visitors' ? 'Actions' : 'Actions'}</TableHeader>}

                </tr>
              </thead>
              <tbody>
                {currentRows.length > 0 ? (
                  currentRows.map((visitor, index) => (

                    <TableRow key={index}>
                      <TableCell> <IconWrapper>
                        <FontAwesomeIcon
                          icon={faEye} // Import faEye from FontAwesome
                          data-tooltip-id="chec-tooltip"
                          data-tooltip-content="View Details"
                          style={{ cursor: 'pointer', marginLeft: '10px' }}
                          onClick={() => handleViewDetails(visitor)}
                        />
                      </IconWrapper></TableCell>
                      <TableCell>
                        <Circle> {visitor.photo ? (
                          <img
                            src={`data:image/png;base64,${visitor.photo}`}
                            alt="Profile"
                            style={{ width: '100%', height: '100%', borderRadius: '50%' }}
                          />
                        ) : (
                          <ProfileIcon>
                            <User size={15} />
                          </ProfileIcon>
                        )}
                        </Circle>
                      </TableCell>
                      <TableCell>{visitor.appointmentId}</TableCell>
                      <TableCell>{visitor.source}</TableCell>
                      <TableCell>{visitor.visitorName}</TableCell>
                      <TableCell>{visitor.visitorTypeDesc}</TableCell>
                      <TableCell>{visitor.visitorMobile}</TableCell>
                      <TableCell>{visitor.nationality}</TableCell>
                      <TableCell>{visitor.idProof}</TableCell>
                      <TableCell>{visitor.host}</TableCell>
                      <TableCell>{visitor.location}</TableCell>
                      {/* <TableCell>{visitor.purpose}</TableCell> */}

                      {/* {cardData !== "expected Visitors" && <TableCell>{visitor.checkInType}</TableCell>} */}
                      <TableCell>
                        {new Intl.DateTimeFormat('en-CA', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit',
                          hour12: false
                        }).format(new Date(visitor.checkInDateTime))
                          .replace(',', ' :')}
                      </TableCell>
                      {cardData === "in Premises" && (
                        <TableCell>
                          {visitor.meetingTo === "0001-01-01T00:00:00" || visitor.meetingTo === null
                            ? " "
                            : new Intl.DateTimeFormat('en-CA', {
                              year: 'numeric',
                              month: '2-digit',
                              day: '2-digit',
                              hour: '2-digit',
                              minute: '2-digit',
                              second: '2-digit',
                              hour12: false,
                            })
                              .format(new Date(visitor.meetingTo))
                              .replace(',', ' :')}
                        </TableCell>
                      )}
                      {cardData !== "in Premises" && cardData !== "crossed Deadlines" && cardData !== "upcoming Deadlines" && <TableCell>
                        {visitor.passReturnedDateTime === "0001-01-01T00:00:00" || visitor.passReturnedDateTime === null
                          ? " "
                          : new Intl.DateTimeFormat('en-CA', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit',
                            hour12: false
                          }).format(new Date(visitor.passReturnedDateTime))
                            .replace(',', ' :')}
                      </TableCell>}
                      <TableCell>{visitor.recurring}</TableCell>
                      <TableCell>{visitor.status}</TableCell>
                      {iconShow && <TableCell>

                        <IconWrapper >
                          <FontAwesomeIcon
                            icon={showIcon}
                            data-tooltip-id="checkin-tooltip" // Link tooltip to the icon
                            data-tooltip-content={cardData == "expected Visitors" ? 'Mobile Check-In' : 'Mobile Check-Out'}// Tooltip content
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              if (cardData !== "expected Visitors") {
                                setQrPopupScreen(true)
                                setQrPopupData({ ...visitor, checkOutType: 'OUT' });
                                // setSelectedVisitor({ mobile: visitor.visitorMobile, cardData, visitor, appointmentId: visitor.appointmentId });
                                // setShowConfirmation(true);
                              } else {
                                handleIconClick(visitor.visitorMobile, cardData, visitor, visitor.appointmentId, "WM");
                              }
                            }} />
                        </IconWrapper>
                        <IconWrapper >
                          <FontAwesomeIcon
                            icon={faIdCard}
                            data-tooltip-id="checkin-tooltip" // Link tooltip to the icon
                            data-tooltip-content={cardData == "expected Visitors" ? 'Id Proof Check-In' : 'Id Proof Check-Out'}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              if (cardData !== "expected Visitors") {
                                setQrPopupScreen(true)
                                setQrPopupData({ ...visitor, checkOutType: 'WID' });
                                // setSelectedVisitor({ mobile: visitor.visitorMobile, cardData, visitor, appointmentId: visitor.appointmentId });
                                // setShowConfirmation(true);
                              } else {
                                handleIconClick(visitor.visitorMobile, cardData, visitor, visitor.appointmentId, "WID");
                              }
                            }}
                          />
                        </IconWrapper>
                        {cardData == "in Premises" &&
                          <IconWrapper >
                            <FontAwesomeIcon
                              icon={faPrint}
                              data-tooltip-id="checkin-tooltip" // Link tooltip to the icon
                              data-tooltip-content='Reprint Pass'
                              style={{ cursor: 'pointer' }}
                              onClick={() => handleReprintPass(visitor)} // Optional: pointer cursor
                            />
                          </IconWrapper>}
                      </TableCell>}


                      <Tooltip id="checkin-tooltip" place="top" className="custom-tooltip" />


                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan="12">
                      <ZeroStateMessage>No visitors to display</ZeroStateMessage>
                    </TableCell>
                  </TableRow>
                )}
              </tbody>
            </StyledTable>
            <Tooltip
              id="chec-tooltip"
              place="bottom"
              effect="solid"
              float={true}
              style={{ zIndex: 9999 }}
            />
            {showDetailsModal && selectedVisitorDetails && (
              <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
              }}>
                <div style={{
                  background: '#fff',
                  borderRadius: '16px',
                  boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)',
                  width: '720px',
                  maxWidth: '95%',
                  padding: '32px',
                  position: 'relative',
                  animation: 'fadeIn 0.3s ease-in-out',
                  fontFamily: 'Segoe UI, sans-serif',
                }}>
                  {/* Close Button */}
                  <button
                    onClick={() => setShowDetailsModal(false)}
                    style={{
                      position: 'absolute',
                      top: '16px',
                      right: '16px',
                      background: 'transparent',
                      border: 'none',
                      fontSize: '24px',
                      cursor: 'pointer',
                      color: '#999',
                    }}
                    aria-label="Close"
                  >
                    &times;
                  </button>

                  {/* Header */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    {selectedVisitorDetails.photo ? (
                      <img
                        src={`data:image/png;base64,${selectedVisitorDetails.photo}`}
                        alt="Visitor"
                        style={{
                          width: '100px',
                          height: '100px',
                          borderRadius: '50%',
                          objectFit: 'cover',
                          border: '3px solid #293495',
                          flexShrink: 0,
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: '100px',
                          height: '100px',
                          borderRadius: '50%',
                          backgroundColor: '#e0e0e0',
                          border: '3px solid #293495',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0,
                        }}
                      >
                        <ProfileIcon>
                          <User size={40} color="#293495" />
                        </ProfileIcon>
                      </div>
                    )}
                    <div style={{ flex: 1 }}>
                      <h2 style={{ margin: '0 0 4px', fontSize: '20px', color: '#293495' }}>
                        {selectedVisitorDetails.visitorName}
                      </h2>
                      <div style={{ fontSize: '14px', color: '#555' }}>
                        <p style={{ margin: '2px 0' }}>
                          <strong>{cardData === 'expected Visitors' ? 'AppId' : 'Visit ID (Appt ID)'}:</strong> {selectedVisitorDetails.appointmentId}
                        </p>
                        <p style={{ margin: '2px 0' }}><strong>Mobile:</strong> {selectedVisitorDetails.visitorMobile}</p>
                      </div>
                    </div>
                  </div>

                  <hr style={{ margin: '24px 0', borderColor: '#e0e0e0' }} />

                  {/* Details Section */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    rowGap: '16px',
                    columnGap: '24px',
                    fontSize: '14px',
                    color: '#333',
                  }}>
                    <Detail label="Visitor Type" value={selectedVisitorDetails.visitorTypeDesc} />
                    <Detail
                      label={cardData === 'expected Visitors' ? 'Appt Type' : 'Visit Type'}
                      value={selectedVisitorDetails.source}
                    />
                    <Detail label="Nationality" value={selectedVisitorDetails.nationality} />
                    <Detail label="Id Proof" value={selectedVisitorDetails.idProof} />
                    <Detail label="Host" value={selectedVisitorDetails.host} />
                    <Detail label="Location" value={selectedVisitorDetails.location} />
                    <Detail label="Purpose" value={selectedVisitorDetails.purpose} />
                    <Detail
                      label={cardData === 'expected Visitors' ? 'Meeting From' : 'Checked-In At'}
                      value={formatDate(selectedVisitorDetails.checkInDateTime)}
                    />
                    {(cardData === 'expected Visitors' ||
                      cardData === 'checked In' ||
                      cardData === 'checked Out' ||
                      cardData === 'in Premises') && (
                        <Detail
                          label={
                            cardData === 'expected Visitors'
                              ? 'Meeting To'
                              : cardData === 'checked In' || cardData === 'checked Out'
                                ? 'Pass Returned At'
                                : 'Meeting End'
                          }
                          value={
                            cardData === 'in Premises'
                              ? selectedVisitorDetails.meetingTo
                              : selectedVisitorDetails.passReturnedDateTime
                                ? formatDate(selectedVisitorDetails.passReturnedDateTime)
                                : ''
                          }
                        />
                      )}

                    <Detail label="Status" value={selectedVisitorDetails.status} />
                    <Detail label="Recurring" value={selectedVisitorDetails.recurring} />
                    {cardData !== 'expected Visitors' && (
                      <>
                        <Detail label="Checked-In By" value={selectedVisitorDetails.checkedInBy || '—'} />
                        <Detail label="Checked-Out By" value={selectedVisitorDetails.checkedOutBy || '—'} />
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}



            {/* {showDetailsModal && selectedVisitorDetails && (
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(0, 0, 0, 0.4)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 9999,
            }}>
              <div style={{
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(10px)',
                borderRadius: '16px',
                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.2)',
                width: '700px',
                maxWidth: '95%',
                padding: '30px',
                animation: 'fadeIn 0.3s ease-out',
              }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <button
                    onClick={() => setShowDetailsModal(false)}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      fontSize: '22px',
                      cursor: 'pointer',
                      color: '#333',
                    }}
                  >
                    &times;
                  </button>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                  <img
                    src={selectedVisitorDetails.photo ? `data:image/png;base64,${selectedVisitorDetails.photo}` : '/default-user.png'}
                    alt="Profile"
                    style={{
                      width: '120px',
                      height: '120px',
                      borderRadius: '50%',
                      border: '4px solid #293495',
                      objectFit: 'cover',
                      flexShrink: 0,
                    }}
                  />

                  <div style={{ flex: 1 }}>
                    <h2 style={{ margin: 0, fontSize: '20px', color: '#293495' }}>
                      {selectedVisitorDetails.visitorName}
                    </h2>
                    <p style={{ margin: '4px 0', fontSize: '14px', color: '#555' }}>
                      <strong>Visit ID (APP ID):</strong> {selectedVisitorDetails.appointmentId}
                    </p>
                    <p style={{ margin: '4px 0', fontSize: '14px', color: '#555' }}>
                      <strong>Mobile:</strong> {selectedVisitorDetails.visitorMobile}
                    </p>
                  </div>
                </div>

                <hr style={{ margin: '20px 0', borderColor: '#eee' }} />

                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '16px',
                  fontSize: '14px',
                  color: '#333'
                }}>
                  <p><strong>Visitor Type:</strong> {selectedVisitorDetails.visitorTypeDesc}</p>
                  <p><strong>Visit Type:</strong> {selectedVisitorDetails.source}</p>
                  <p><strong>Nationality:</strong> {selectedVisitorDetails.nationality}</p>
                  <p><strong>Host:</strong> {selectedVisitorDetails.host}</p>
                  <p><strong>Location:</strong> {selectedVisitorDetails.location}</p>
                  <p><strong>Purpose:</strong> {selectedVisitorDetails.purpose}</p>
                  <p><strong>Checked-In:</strong> {formatDate(selectedVisitorDetails.checkInDateTime)}</p>
                  {selectedVisitorDetails.passReturnedDateTime && (
                    <p><strong>Pass Returned:</strong> {formatDate(selectedVisitorDetails.passReturnedDateTime)}</p>
                  )}
                  <p><strong>Status:</strong> {selectedVisitorDetails.status}</p>
                  <p><strong>Recurring:</strong> {selectedVisitorDetails.recurring}</p>
                  <p><strong>Checked-In By:</strong> {selectedVisitorDetails.checkedInBy || '—'}</p>
                  <p><strong>Checked-Out By:</strong> {selectedVisitorDetails.checkedOutBy || '—'}</p>
                </div>
              </div>
            </div>
          )} */}


            {showConfirmation && (
              <div style={{
                position: 'fixed',
                top: '50%',
                left: '55%',
                transform: 'translate(-50%, -50%)',
                background: '#fff',
                boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.3)',
                borderRadius: '10px',
                padding: '30px',
                textAlign: 'center',
                opacity: 1,
                zIndex: 1000,
                width: '400px',
                height: '125px',
              }}>
                <p style={{ marginBottom: '20px', fontSize: '16px', fontWeight: 500 }}>
                  Are you sure you want to check out this visitor?
                </p>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                  <button
                    onClick={() => {
                      handleIconClick(selectedVisitor.mobile, selectedVisitor.cardData, selectedVisitor.visitor);
                      setShowConfirmation(false);
                      setSelectedVisitor(null);
                    }}
                    style={{
                      backgroundColor: '#293495',
                      color: '#fff',
                      padding: '8px 20px',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer',
                    }}
                  >
                    Yes
                  </button>
                  <button
                    onClick={() => {
                      setShowConfirmation(false);
                      setSelectedVisitor(null);
                    }}
                    style={{
                      backgroundColor: 'red',
                      color: '#fff',
                      padding: '8px 20px',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer',
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            )}

            {showPopup && (
              <Popup>
                <PopupText>Checkout already done for this Visitor</PopupText>
                <PopupButton onClick={handleClosePopup}>OK</PopupButton>
              </Popup>
            )}
            {showPopupC && (
              <Popup>
                <PopupText>Check In already done for this Visitor</PopupText>
                <PopupButton onClick={handleClosePopupC}>OK</PopupButton>
              </Popup>
            )}
            {showPopupSuc && (
              <Popup>
                <PopupText> Visitor Left</PopupText>
                <PopupButton onClick={handleClosePopupSuc}>OK</PopupButton>
              </Popup>
            )}
            {/* Render Popup when isPopupVisible is true */}
            {/* {isPopupVisible && (
            <PopupCh>
              <PopupText>Scan QR Code:</PopupText>
              <InputField
                type="text"
                placeholder="Scan QR Code"
                maxLength="29"
                value={qrumber}
                onChange={handleInputQrChange}
              />
              <PopupButton onClick={closePopup} style={{ backgroundColor: 'red' }}>Close</PopupButton>
              <PopupButton onClick={handleNextButtonQRClick} style={{ marginLeft: '10px' }}>Next</PopupButton>

            </PopupCh>
          )} */}
            {isPopupVisibleOut && (
              <PopupCh>
                <PopupText>Scan QR Code:</PopupText>
                <InputField
                  type="text"
                  placeholder="Scan QR Code"
                  value={qrumber}
                  onChange={handleInputQrChangeN}
                />
                <PopupButton onClick={closePopupOut} style={{ backgroundColor: 'red' }}>Close</PopupButton>
                <PopupButton onClick={handleNextButtonQRClickOut} style={{ marginLeft: '10px' }}>Next</PopupButton>

              </PopupCh>
            )}

            <PaginationContainer>
              <PaginationButton onClick={handlePrevPage} disabled={currentPage === 1}>
                Previous
              </PaginationButton>

              <DropdownSelect value={currentPage} onChange={handlePageChange}>
                {Array.from({ length: totalPages }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {i + 1}
                  </option>
                ))}
              </DropdownSelect>

              <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
                Next
              </PaginationButton>
            </PaginationContainer>
          </TableContainer>

        )
      }

      {
        showTableFilter && (

          <TableContainer>
            <StyledTable>
              <thead>
                <tr>
                  <TableHeader onClick={() => handleSort('visitorName')}>Visitor Name{sortColumn === 'visitorName' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('visitorTypeDesc')}>Visitor Type{sortColumn === 'visitorTypeDesc' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('visitorMobile')}>Mobile{sortColumn === 'visitorMobile' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('checkinType')}>Check-In Type{sortColumn === 'checkinType' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('gate')}>Gate{sortColumn === 'gate' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('checkInDateTime')}>Check-In Date{sortColumn === 'checkInDateTime' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader onClick={() => handleSort('passReturnedDateTime')}>Check-Out Date{sortColumn === 'passReturnedDateTime' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>

                </tr>
              </thead>
              <tbody>
                {currentRowsGate.length > 0 ? (
                  currentRowsGate.map((visitor, index) => (
                    <TableRow key={index}>
                      <TableCell>{visitor.visitorName}</TableCell>
                      <TableCell>{visitor.visitorTypeDesc}</TableCell>
                      <TableCell>{visitor.visitorMobile}</TableCell>
                      <TableCell>{visitor.checkinType}</TableCell>
                      <TableCell>{visitor.gate}</TableCell>
                      <TableCell>
                        {new Intl.DateTimeFormat('en-CA', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit',
                          hour12: false
                        }).format(new Date(visitor.checkInDateTime))
                          .replace(',', ' :')}
                      </TableCell>
                      <TableCell>
                        {new Intl.DateTimeFormat('en-CA', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit',
                          hour12: false
                        }).format(new Date(visitor.passReturnedDateTime))
                          .replace(',', ' :')}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan="7">
                      <ZeroStateMessage>No visitors to display</ZeroStateMessage>
                    </TableCell>
                  </TableRow>
                )}
              </tbody>
            </StyledTable>

            <PaginationContainer showPagination={totalPages > 1}>
              <PaginationButton onClick={() => handlePageChange('prev')} disabled={currentPage === 0}>Previous</PaginationButton>
              <PaginationButton onClick={() => handlePageChange('next')} disabled={currentPage >= totalPages - 1}>Next</PaginationButton>
            </PaginationContainer>

          </TableContainer>


        )
      }
      {
        isPopupVisible && (
          <PopupOverlay>
            <PopupCh>
              <PopupText>Scan QR Code:</PopupText>
              <InputField
                type="text"
                placeholder="Scan QR Code"
                value={qrumber}
                onChange={handleInputQrChange}
              />
              <PopupButton onClick={closePopup} style={{ backgroundColor: 'red' }}>Close</PopupButton>
              <PopupButton onClick={handleNextButtonQRClick} style={{ marginLeft: '10px' }}>Next</PopupButton>

            </PopupCh>
          </PopupOverlay>
        )
      }

      {
        isPopupVisibleMobile && (
          <PopupOverlay>

            <PopupCh>
              <PopupText>Walk-In Check-In</PopupText>

              <StyledLabel className={selected === "number" ? "active" : ""}>
                <input
                  type="radio"
                  name="option"
                  value="number"
                  checked={selected === "number"}
                  onChange={(e) => setSelected(e.target.value)}
                />
                Number
              </StyledLabel>

              <StyledLabel className={selected === "idproof" ? "active" : ""}>
                <input
                  type="radio"
                  name="option"
                  value="idproof"
                  checked={selected === "idproof"}
                  onChange={(e) => setSelected(e.target.value)}
                />
                ID Proof
              </StyledLabel>

              {selected === "number" &&
                <div>
                  <InputWrapper>
                    {/* <span>ISD+{defaultNationalityCode}</span> */}
                    <ISDSelect onChange={handleIsdChange} value={defaultNationalityCode}
                      title={
                        Array.isArray(nationalityList) && nationalityList.length > 0
                          ? (() => {
                            const selectedNation = nationalityList.find(
                              (nation) => nation.nationalityCode === defaultNationalityCode
                            );
                            return selectedNation
                              ? `${selectedNation.name} (${selectedNation.nationalityCode})`
                              : 'Select Nationality';
                          })()
                          : 'Loading...'
                      }
                    >

                      {Array.isArray(nationalityList) && nationalityList.length > 0 ? (
                        <>
                          <option value="" disabled selected>
                            Select Nationality
                          </option>
                          {nationalityList.map((nation) => (
                            <option
                              key={nation.id}
                              value={nation.nationalityCode}
                              disabled={nation.isBlackListed}
                            >
                              {nation.name} ({nation.nationalityCode})
                            </option>
                          ))}
                        </>
                      ) : (
                        <option value="" disabled>Loading...</option>
                      )}
                    </ISDSelect>
                    <StyledInput
                      type="text"
                      maxLength={defaultNationalityCode === "91" ? 10 : 15}
                      value={mobileNumber}
                      onChange={handleInputChange}
                      placeholder="Please enter your mobile number."
                    />
                  </InputWrapper>
                  <PopupButton onClick={closePopup} style={{ backgroundColor: 'red' }}>Close</PopupButton>
                  <PopupButton onClick={handleNextButtonWalkingCheckin} style={{ marginLeft: '10px' }}>Next</PopupButton>
                </div>
              }

              {selected === "idproof" &&
                <div>
                  <InputWrapper>
                    <ISDSelect
                      name="selectedIdProofTypeId"
                      value={selectedIdProofTypeId}
                      onChange={e => setSelectedIdProofTypeId(e.target.value)}
                    >
                      <option value="">Select ID Proof Type</option>
                      {idProofTypes.map((type) => (
                        <option key={type.id} value={type.id}>{type.idProofDescription}</option>
                      ))}
                    </ISDSelect>
                    <StyledInput
                      type="text"
                      maxLength={4}
                      placeholder="Please enter your ID proof number."
                      value={idProof}
                      onChange={(e) => setIdProof(e.target.value)}
                    />

                  </InputWrapper>

                  <PopupButton onClick={closePopup} style={{ backgroundColor: 'red' }}>Close</PopupButton>
                  <PopupButton onClick={handleNextButtonWalkingCheckinIDProof} style={{ marginLeft: '10px' }}>Next</PopupButton>
                </div>
              }
            </PopupCh>
          </PopupOverlay>

        )
      }


      {showBaggageTag && (
        <PopupOverlay>

          <div style={{
            backgroundColor: 'white',
            borderRadius: '1.5rem',
          }}>

            <div dangerouslySetInnerHTML={{ __html: baggageTag }} />

          </div>

        </PopupOverlay>

      )}
      <ToastContainer />

    </DashboardWrapper >
  );
};

export default Dashboard;